<template>
    <div class="container-fluid" id="dvcrud">
        <div class="row">
            <div class="col-md-12">
                <breadcrumb v-bind:bcitens="itensbc" v-bind:mtdcancelar="mtdcancelaredicao"></breadcrumb>
            </div>
            <div class="col-md-12">
                <div id="pnlista" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">PAINEL DE {{ itensbc.item1.titulo }}</span>
                        <router-link to="/">
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                        </router-link>
                        <export-excel style="display: none;" id="btexportarexcel"
                            :data   = "lstclientes"
                            :fields = "json_fields"
                            name    = "clientes.xls">
                        </export-excel>                         
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" title="Importar cadastros de clientes" style="margin-right: 10px;" @click.prevent="mtdrotinaimportacao()"><span aria-hidden="true"><i class="fa fa-download"></i></span></button>                                                
                    </div>
                    <div class="card-body" style="padding: 10px;">
                        <div class="row">
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <label for="cbopfiltro">Filtrar:</label>
                                <select name="cbopfiltro" class="form-control form-control-sm" id="cbopfiltro" v-model="pfiltro" @change="mtdlimpar_listagem()">
                                    <option value="0">Código</option>
                                    <option value="1">Nome/Razão Social</option>
                                    <option value="2">Fantasia</option>
                                    <option value="3">Cnpj/Cpf</option>
                                    <option value="4">Insc.Estadual/Rg</option>
                                    <option value="5">Nº Cartão</option>
                                    <option value="6">Telefone(1)</option>
                                    <option value="7">Telefone(2)</option>
                                </select>
                            </div>
                            <div class="col-sm-4 col-md-4 col-lg-4">
                                <label for="edconteudopesq">Conteúdo da pesquisa:</label>
                                <input id="edconteudopesq" type="text" class="form-control form-control-sm" v-model="pconteudo" @keyup="mtdlimpar_listagem()">
                            </div>
                            <div class="col-sm-12 col-md-2 col-lg-1">
                                <label for="cbtipopessoapesq">Pessoa:</label>
                                <select class="form-control form-control-sm" id="cbtipopessoapesq" v-model="ptipopessoa" @change="mtdlimpar_listagem()">
                                    <option value="0">Física</option>
                                    <option value="1">Jurídica</option>
                                    <option value="2">Extrangeiro</option>
                                    <option value="3">Todas</option>
                                </select>
                            </div>                            
                            <div class="col-sm-2 col-md-2 col-lg-1">
                                <label for="cbqtdreg">Situação:</label>
                                <select name="cbSituacao" class="form-control form-control-sm" id="cbSituacao" v-model="psituacao" @change="mtdlimpar_listagem()">
                                    <option value="0">Ativos</option>
                                    <option value="1">Inativos</option>
                                    <option value="2">Todos</option>
                                </select>
                            </div> 
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <span class="lblselect2">Município:</span>
                                <select id="cbmunicipiopesq" data-placeholder="Selecione um município" v-model="pidmunicipio" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                                                         
                            <div class="col-sm-3 col-md-2 col-lg-2">
                                <span class="lblselect2">Vendedor:</span>
                                <select id="cbvendedorpesq" data-placeholder="Selecione um vendedor" v-model="pidvendedor" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div> 
                            <div class="col-sm-4 col-md-2 col-lg-2">
                                <span class="lblselect2">Categoria:</span>
                                <select id="cbcategoriapesq" data-placeholder="Selecione uma categoria" v-model="pidcategoria" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div> 
                            <div class="col-sm-3 col-md-2 col-lg-2">
                                <span class="lblselect2">Rota:</span>
                                <select id="cbrotapesq" data-placeholder="Selecione uma rota" v-model="pidrota" data-allow-clear="true" style="width:100%;">
                                </select>
                            </div>                                                                                                                                               
                            <div class="col-6 col-sm-6 col-md-1 col-lg-1">
                                <label for="cbqtdreg">Itens exibidos:</label>
                                <select name="cbqtdreg" class="form-control form-control-sm" id="cbqtdreg" v-model="pqtdregistros" @change="mtdlimpar_listagem()">
                                    <option value="10">10</option>
                                    <option value="20">20</option>
                                    <option value="30">30</option>
                                    <option value="40">40</option>
                                    <option value="50">50</option>
                                    <option value="99999999999">Todos</option>
                                </select>
                            </div>
                            <template v-if="pmaisfiltros">
                                <div class="col-sm-12 col-md-2 col-lg-1">
                                    <label for="cbfracionadopesq">Adquiridos:</label>
                                    <select name="cbfiltrocadastropesq" class="form-control form-control-sm" id="cbfiltrocadastropesq" v-model="pfiltroadquiridospesq" @change="mtdlimpar_listagem()">
                                        <option value="0">Não</option>
                                        <option value="1">Sim</option>
                                    </select>
                                </div>                            
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="eddtini">Período de:</label>
                                    <div class="input-group">
                                        <date-picker id="eddtini" v-model="pdtini" :config="options" class="form-control form-control-sm" v-bind:disabled="parseInt(pfiltroadquiridospesq) === 0"></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>								
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-2 col-lg-2">
                                    <label for="eddtfim">Até:</label>
                                    <div class="input-group">
                                        <date-picker id="eddtfim" v-model="pdtfim" :config="options" class="form-control form-control-sm" v-bind:disabled="parseInt(pfiltroadquiridospesq) === 0"></date-picker>
                                        <div class="input-group-append">
                                            <span class="input-group-text"><i class="fa fa-calendar"></i></span>
                                        </div>																			
                                    </div>
                                </div>						                                
                            </template>                            
                            <div class="col-1 col-sm-1 col-md-1 col-lg-1">
                                <button type="button" id="btmaisfiltros" class="btn btn-secondary btn-block btn-sm" @click.prevent="mtdmaisfiltros()" title="Mais opções de filtro"><i class="fa" v-bind:class="pmaisfiltros === false ? 'fa-angle-double-down' : 'fa-angle-double-up'"></i></button>
                            </div>                            
                            <div class="col-6 col-sm-6 col-md-2 col-lg-1">
                                <button type="button" id="btlistar" class="btn btn-primary btn-sm btn-block" @click.prevent="mtdexecutapesquisa()"><i class="fa fa-search"></i></button>
                            </div>
                            <div class="col-md-12" style="margin-top: 10px;">
                                <vue-bootstrap4-table ref="reflstclientes"
                                        :rows="lstclientes"
                                        :columns="columns"
                                        :config="config"
                                        :classes="classes">
                                    <template slot="empty-results">
                                        <div class="col-md-12 text-center">Sem dados para visualização</div>
                                    </template>
                                    <!-- ícones de ordenação da table -->
                                    <template slot="sort-asc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-asc"></i>
                                    </template>
                                    <template slot="sort-desc-icon">
                                        <i class="fa-icones-ordenacao fa fa-sort-desc"></i>
                                    </template>
                                    <template slot="no-sort-icon">
                                        <i class="fa-icones-ordenacao fa fa-unsorted"></i>
                                    </template>                                    
                                    <!--  -->                                    
                                    <template slot="id_f" slot-scope="item">
                                        {{ item.row.id }}
                                    </template>
                                    <template slot="ativo_f" slot-scope="item">
                                        <span v-if="item.row.ativo === 0" class="badge badge-pill badge-primary">Ativo</span>
                                        <span v-else class="badge badge-pill badge-danger">Inativo</span>
                                    </template>  
                                    <template slot="fone_f" slot-scope="item">
                                        {{ mtdformatafone(item.row.fone1) }}
                                    </template>                                                                        
                                    <template slot="cnpjcpf_f" slot-scope="item">
                                        {{ formatacpfcnpj(item.row.cnpjcpf) }}
                                    </template>                                  
                                    <template slot="slot_tipopessoa" slot-scope="item">
                                        <span v-if="parseInt(item.row.tipopessoa) === 0" class="badge badge-pill badge-secondary">Física</span>
                                        <span v-else-if="(parseInt(item.row.tipopessoa) === 1)" class="badge badge-pill badge-warning">Jurídica</span>                                        
                                        <span v-else class="badge badge-pill badge-info">Estrangeira</span>                                                                                
                                    </template>                                      
                                    <template slot="opcoes" slot-scope="item">
                                        <button type="button" class="btn btn-info btn-sm btn-opcrud ajt-btn" @click.prevent="mtdalterar(item.row)"><i class="fa fa-edit"></i></button>
                                        <button type="button" class="btn btn-danger btn-sm btn-opcrud ajt-btn" @click.prevent="mtdexcluir(item.row)"><i class="fa fa-trash"></i></button>
                                    </template>
                                </vue-bootstrap4-table>
                            </div>
                            <div class="col-md-12">
                                <ul class="list-group">
                                    <li class="list-group-item d-flex justify-content-between align-items-center" style="padding: 10px;">
                                        Itens exibidos
                                        <span class="badge badge-info badge-pill text-right bdg-qtd-reg-info">{{lstclientes.length}}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-6 col-sm-6 col-md-8 col-lg-8" id="dvpaginacao">
                                <v-pagination
                                        v-model="pagina_atual"
                                        :page-count="pqtd_paginas"
                                        :classes="bootstrapPaginationClasses">
                                </v-pagination>
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <!-- <button type="button" class="btn btn-info btn-sm btn-block" @click.prevent="mtdgerarpdf()"><i class="fa fa-print"></i> Imprimir</button> -->                              
                                <div class="dropdown">
                                    <button type="button" class="btn btn-info btn-sm btn-block dropdown-toggle" data-toggle="dropdown">
                                        <i class="fa fa-navicon"></i> Outras
                                    </button>
                                    <div class="dropdown-menu">
                                        <a class="dropdown-item" href="#" @click.prevent="mtdrotinaplano()"><i class="fa fa-user-plus"></i> Atribuir/Remover planos de pagamento</a>
                                        <a class="dropdown-item" href="#" @click.prevent="mtdgerarpdf(false)"><i class="fa fa-print"></i> Imprimir</a>  
                                        <a class="dropdown-item" href="#" @click.prevent="mtdgerarpdf(true)"><i class="fa fa-file-excel-o"></i> Exportar excel</a>                                                                                                                   
                                    </div>
                                </div>                                                
                            </div>                                                       
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-success btn-sm btn-block" @click.prevent="mtdnovo()"><i class="fa fa-file"></i> Criar</button>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="pncadastro" class="card" style="display:none;">
                    <div class="card-header"><span>{{itensbc.item2.titulo}}</span>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-md-10" style="margin-bottom: 15px;">
                                <div class="row">
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="edid">ID interno:</label>
                                        <input type="text" class="form-control form-control-sm" id="edid" v-model="vid"
                                            maxlength="20" style="text-transform: uppercase;" disabled/>
                                    </div>
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="cbtipopessoa">Tipo de Pessoa:</label>
                                        <select class="form-control form-control-sm" id="cbtipopessoa" v-model="vtipopessoa"
                                                v-bind:disabled="ativadesativa">
                                            <option value="0">Física</option>
                                            <option value="1">Jurídica</option>
                                            <option value="2">Extrangeiro</option>
                                        </select>
                                    </div>  
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="cbtipocontribuinte">Tipo de Contribuinte:</label>
                                        <select class="form-control form-control-sm" id="cbtipocontribuinte" v-model="vtipocontribuinte"
                                                v-bind:disabled="ativadesativa">
                                            <option value="1">Contribuinte ICMS</option>
                                            <option value="2">Contribuinte ISENTO</option>
                                            <option value="9">Não Contribuinte</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="cbativo">Situação:</label>
                                        <select class="form-control form-control-sm" id="cbativo" v-model="vsituacao"
                                                v-bind:disabled="ativadesativa">
                                            <option value="0">Ativo</option>
                                            <option value="1">Inativo</option>
                                        </select>
                                    </div>
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="ednrcartao">Nº Cartão:</label>
                                        <input type="text" v-model="vnrcartao" v-bind:disabled="ativadesativa"
                                            class="form-control form-control-sm" id="ednrcartao" maxlength="30"
                                            style="text-transform: uppercase;">
                                    </div>
                                    <div class="col-sm-12 col-md-2 col-lg-2" v-if="opcrud === 1"> 
                                    <label for="eddtcadastro_fk">Data Cadastro:</label>
                                        <input type="text" disabled="disabled"
                                            class="form-control form-control-sm" id="eddtcadastro_fk">                               
                                    </div>
                                    <div class="col-sm-12 col-md-2 col-lg-2" v-else>
                                        <label for="eddtcadastro">Data Cadastro:</label>
                                        <date-picker id="eddtcadastro" v-model="vdtcadastro" :config="options" class="form-control form-control-sm" disabled="disabled"></date-picker>
                                    </div>
                                    <div class="col-sm-12 col-md-5 col-lg-5">
                                        <label for="ednome">*Razão Social:</label>
                                        <input type="text" v-model="vnome" v-bind:disabled="ativadesativa"
                                            class="form-control form-control-sm" id="ednome" maxlength="80"
                                            style="text-transform: uppercase;">
                                    </div>                            
                                    <div class="col-sm-12 col-md-5 col-lg-5">
                                        <label for="edfantasia">*Fantasia:</label>
                                        <input type="text" v-model="vfantasia" v-bind:disabled="ativadesativa"
                                            class="form-control form-control-sm" id="edfantasia" maxlength="80"
                                            style="text-transform: uppercase;">
                                    </div>                         
                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                        <label for="cbavulso">Cliente avulso:</label>
                                        <select class="form-control form-control-sm" id="cbativo" v-model="vavulso" title="Informar 'Sim' apenas para consumidor(Cliente balcão)."
                                                v-bind:disabled="ativadesativa">
                                            <option value="0">Não</option>
                                            <option value="1">Sim</option>
                                        </select>
                                    </div>                                                                  
                                    <div class="col-sm-3 col-md-3 col-lg-3">
                                        <label for="cbfilial">*Filial:</label>
                                        <select id="cbfilial" v-model="vidfilial" v-bind:disabled="ativadesativa"
                                                data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                style="width:100%;">
                                        </select>
                                    </div> 
                                    <div class="col-sm-3 col-md-3 col-lg-3">
                                        <span class="lblselect2">*Vendedor:</span>
                                        <select id="cbvendedor" data-placeholder="Selecione um vendedor" v-model="vidvendedor" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                        </select>
                                    </div>                                                                               
                                    <div class="col-sm-3 col-md-3 col-lg-3">
                                        <span class="lblselect2">Categoria:</span>
                                        <select id="cbcategoria" data-placeholder="Selecione uma categoria" v-model="vidcategoria" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                        </select>
                                    </div>
                                    <div class="col-sm-3 col-md-3 col-lg-3">
                                        <span class="lblselect2">Rota:</span>
                                        <select id="cbrota" data-placeholder="Selecione uma rota" v-model="vidrota" v-bind:disabled="ativadesativa" data-allow-clear="true" style="width:100%;">
                                        </select>
                                    </div>                                                                                                           
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="row text-center" style="padding: 0px 15px 0px 15px; margin-bottom: 15px;">
                                    <div class="col-md-12 border rounded" style="padding: 0px;">
                                        <input
                                            type="file" 
                                            id="ipselecionarimgcliente"
                                            accept="image/png, image/jpeg" 
                                            @change="mtdselecionarimagemcliente" 
                                            style="display: none;"
                                            ref="if_imgcliente">
                                        <button v-if="parseInt(opcrud) < 3" type="button" class="btn btn-danger btn-sm btn-del-imgcliente" @click.prevent="mtdexcluirimgcliente()"><i class="fa fa-trash"></i></button>
                                        <img v-if="parseInt(opcrud) < 3" @click="$refs.if_imgcliente.click()" class="img-fluid img-filial" title="Clique aqui para selecionar uma imagen" v-bind:src="pathimagemvisualizar"> 
                                        <img v-else class="img-fluid img-cliente" v-bind:src="pathimagemvisualizar">                                         
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-md-12" style="margin-top: 15px;">
                                <ul class="nav nav-tabs" id="myTab" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" id="tabendereco" data-toggle="tab" href="#dvendereco" role="tab" aria-controls="Endereço" aria-selected="true">Endereço</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="tabprincipal" data-toggle="tab" href="#dvprincipal" role="tab" aria-controls="Principal" aria-selected="false">Principal</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="tabtrabalhorenda" data-toggle="tab" href="#dvtrabalhorenda" role="tab" aria-controls="Trabalho/Renda" aria-selected="false">Trabalho/Renda</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="tabconjuge" data-toggle="tab" href="#dvconjuge" role="tab" aria-controls="Cônjuge" aria-selected="false">Cônjuge</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="tabfiadorref" data-toggle="tab" href="#dvfiadorref" role="tab" aria-controls="Fiador/Referência" aria-selected="false">Fiador/Referência</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="tabcredito" data-toggle="tab" href="#dvcredito" role="tab" aria-controls="Crédito" aria-selected="false">Crédito</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="tabplanospagamento" data-toggle="tab" href="#dvplanospagamento" role="tab" aria-controls="Planos de pagamento" aria-selected="false">Planos de pagamento</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" id="tabobservacoes" data-toggle="tab" href="#dvobservacoes" role="tab" aria-controls="Anotações" aria-selected="false">Anotações</a>
                                    </li>
                                </ul>

                                <div class="tab-content border-left border-right border-bottom" id="dvconteudotab" style="padding-top: 15px; padding-bottom: 15px;">
                                    <!-- ENDEREÇO -->
                                    <div class="tab-pane container-fluid active" id="dvendereco" role="tabpanel" aria-labelledby="endereco-tab">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edcep">*Cep:</label>
                                                <input type="text" v-model="vcep" v-bind:disabled="ativadesativa" v-mask="'#####-###'"
                                                    class="form-control form-control-sm" id="edcep">
                                            </div>
                                            <div class="col-sm-12 col-md-8 col-lg-8">
                                                <label for="edlogradouro">*Endereço:</label>
                                                <input type="text" v-model="vlogradouro" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edlogradouro" maxlength="100"
                                                    style="text-transform: uppercase;">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="ednrendereco">*Nº Endereço:</label>
                                                <input type="text" v-model="vnrendereco" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="ednrendereco" maxlength="20"
                                                    style="text-transform: uppercase;">
                                            </div> 
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="edcomplementoend">Complemento:</label>
                                                <input type="text" v-model="vcomplementoend" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edcomplementoend" maxlength="100"
                                                    style="text-transform: uppercase;">
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="edperimetroend">Perímetro:</label>
                                                <input type="text" v-model="vperimetroend" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edperimetroend" maxlength="100"
                                                    style="text-transform: uppercase;">
                                            </div>                                                        
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="cbbairro">*Bairro:</label>
                                                <select id="cbbairro" v-model="vidbairro" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                        style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="cbmunicipio">*Município:</label>
                                                <select id="cbmunicipio" v-model="vidmunicipio"
                                                        v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione uma opção" data-allow-clear="true"
                                                        style="width:100%;">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbuf">*Estado:</label>
                                                <select id="cbuf" v-model="viduf" v-bind:disabled="ativadesativa"
                                                        data-placeholder="Selecione a uf" data-allow-clear="true"
                                                        style="width:100%;">
                                                </select>
                                            </div>                                            
                                        </div>
                                    </div>
                                    <!-- FIM ENDEREÇO -->

                                    <!-- PRINCIPAL -->
                                    <div class="tab-pane container-fluid" id="dvprincipal" role="tabpanel" aria-labelledby="principal-tab">
                                        <!-- PESSOA FÍSICA -->
                                        <div class="row" v-if="parseInt(vtipopessoa) === 0">
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edcnpjcpf">*CPF</label>
                                                <input type="text" v-model="vcnpjcpf" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edcnpjcpf" 
                                                    v-mask="'###.###.###-##'">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edrginsc">RG:</label>
                                                <input type="text" v-model="vrginsc" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edrginsc" maxlength="20">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="ediepf">IE:</label>
                                                <input type="text" v-model="viepf" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edidpf" maxlength="20">
                                            </div>                                            
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddtnascfund">Data Nascimento:</label>
                                                <date-picker id="eddtnascfund" v-model="vdtnascfund" :config="options" 
                                                    class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edcarteiraprof">Cart. Profissional:</label>
                                                <input type="text" v-model="vcarteiraprof" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edcarteiraprof" maxlength="20">
                                            </div> 
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edqtddependentes">Qtd. Dependentes:</label>
                                                <input type="number" v-model="vqtddependentes" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edqtddependentes" min="0">
                                            </div>

                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbestadocivil">Estado civil:</label>
                                                <select class="form-control form-control-sm" id="cbestadocivil" v-model="vestadocivil"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0">SOLTEIRO(A)</option>
                                                    <option value="1">CASADO(A)</option>
                                                    <option value="2">DIVORCIADO(A)</option>
                                                    <option value="3">VIÚVO(A)</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="ednacionalidade">Nacionalidade:</label>
                                                <input type="text" v-model="vnacionalidade" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="ednacionalidade" maxlength="20"
                                                    style="text-transform: uppercase;">
                                            </div> 
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="ednaturalidade">Naturalidade:</label>
                                                <input type="text" v-model="vnaturalidade" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="ednaturalidade" maxlength="20"
                                                    style="text-transform: uppercase;">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbsexo">Sexo:</label>
                                                <select class="form-control form-control-sm" id="cbsexo" v-model="vsexo"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0">MASCULINO</option>
                                                    <option value="1">FEMININO</option>
                                                    <option value="2">INDEFINIDO</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbresidencia">Residência:</label>
                                                <select class="form-control form-control-sm" id="cbresidencia" v-model="wt_residencia"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0">PRÓPRIA</option>
                                                    <option value="1">ALUGADA</option>
                                                    <option value="2">FINANCIADA</option>
                                                    <option value="3">TEMPORÁRIA</option>
                                                    <option value="4">DOS PAIS</option>
                                                </select>
                                            </div> 
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edvlaluguel">{{ labelCustoCasa }}</label>
                                                <money class="form-control form-control-sm" id="edvlaluguel" v-bind="money" v-model="vvlaluguel"
                                                    value="0,00" data-bv-group=".group"
                                                    v-bind:disabled="bativaCustoCasa"
                                                    style="text-align:right;"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="ednomepai">Pai:</label>
                                                <input type="text" v-model="vnomepai" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="ednomepai" maxlength="50"
                                                    style="text-transform: uppercase;">
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="ednomemae">Mãe:</label>
                                                <input type="text" v-model="vnomemae" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="ednomemae" maxlength="50"
                                                    style="text-transform: uppercase;">
                                            </div>                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                
                                        </div>
                                        <!-- PESSOA JURÍDICA -->
                                        <div class="row" v-else>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edcnpjcpf">Cnpj</label>
                                                <input type="text" v-model="vcnpjcpf" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edcnpjcpf" 
                                                    v-mask="'##.###.###/####-##'">
                                            </div> 
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edrginsc">IE:</label>
                                                <input type="text" v-model="vrginsc" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edrginsc" maxlength="20">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edinscsuframa">Suframa:</label>
                                                <input type="text" v-model="vinscsuframa" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edinscsuframa" maxlength="20"
                                                    style="text-transform: uppercase;">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edinscmunicipal">Insc. Municipal:</label>
                                                <input type="text" v-model="vinscricaomunicipal" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edinscmunicipal" maxlength="15">
                                            </div>                                            
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edidestrangeiro">Id. Estrangeiro:</label>
                                                <input type="text" v-model="videstrangeiro" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edidestrangeiro" maxlength="20">
                                            </div>                                                                                                                                    
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddtnascfund">Data Fundação:</label>
                                                <date-picker id="eddtnascfund" v-model="vdtnascfund" :config="options" 
                                                    class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
                                            </div>                                                                                                                                    
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edfone1">*Fone:</label>
                                                <input type="text" v-model="vfone1" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edfone1" 
                                                    v-mask="['(##) ####-####', '(##) #####-####']">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edfone2">Fone:</label>
                                                <input type="text" v-model="vfone2" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edfone2" 
                                                    v-mask="['(##) ####-####', '(##) #####-####']">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edfone3">Fone:</label>
                                                <input type="text" v-model="vfone3" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edfone3" 
                                                    v-mask="['(##) ####-####', '(##) #####-####']">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edcelular">Celular:</label>
                                                <input type="text" v-model="vcelular" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edcelular" 
                                                    v-mask="['(##) ####-####', '(##) #####-####']">
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edcontato">Contato:</label>
                                                <input type="text" v-model="vcontato" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edcontato" maxlength="50"
                                                    style="text-transform: uppercase;">
                                            </div> 
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="edemail">E-mail:</label>
                                                <input type="email" v-model="vemail" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edemail" maxlength="100"
                                                    style="text-transform: lowercase;">
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="edsite">Website:</label>
                                                <input type="text" v-model="vsite" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edsite" maxlength="200"
                                                    style="text-transform: lowercase;">
                                            </div>
                                        </div>                                        
                                    </div>
                                    <!-- FIM PRINCIPAL -->

                                    <!-- TRABALHO E RENDA -->
                                    <div class="tab-pane container-fluid" id="dvtrabalhorenda" role="tabpanel" aria-labelledby="trabalhorenda-tab">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="edlocaltrab">Local de trabalho:</label>
                                                <input type="text" v-model="vlocaltrab" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edlocaltrab" maxlength="50"
                                                    style="text-transform: uppercase;">
                                            </div>
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="edtiposervico">Tipo de serviço:</label>
                                                <input type="text" v-model="vtiposervico" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edtiposervico" maxlength="50"
                                                    style="text-transform: uppercase;">
                                            </div>                                            
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="edcargotrab">Cargo ocupado:</label>
                                                <input type="text" v-model="vcargotrab" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edcargotrab" maxlength="50"
                                                    style="text-transform: uppercase;">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edrendasalarial">Renda salarial:</label>
                                                <money class="form-control form-control-sm" id="edrendasalarial" v-bind="money" v-model="vrendasalarial"
                                                    value="0,00" data-bv-group=".group" v-bind:disabled="ativadesativa"
                                                    style="text-align:right;"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edrendaextra">Renda extra:</label>
                                                <money class="form-control form-control-sm" id="edrendaextra" v-bind="money" v-model="vrendaextra"
                                                    value="0,00" data-bv-group=".group" v-bind:disabled="ativadesativa"
                                                    style="text-align:right;"></money>
                                            </div> 
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edfonetrab">Fone:</label>
                                                <input type="text" v-model="vfonetrab" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edfonetrab" 
                                                    v-mask="['(##) ####-####', '(##) #####-####']">
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-12 col-md-12 col-lg-12">
                                                <label for="edenderecotrab">Endereço:</label>
                                                <input type="text" v-model="venderecotrab" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edenderecotrab" maxlength="100"
                                                    style="text-transform: uppercase;">
                                            </div>                                           
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbpossuibens">Possui bens:</label>
                                                <select class="form-control form-control-sm" id="cbpossuibens" v-model="wt_possuibens"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0">Não</option>
                                                    <option value="1">Sim</option>
                                                </select>
                                            </div>  
                                            <div class="col-sm-12 col-md-10 col-lg-10">
                                                <label for="edoutrosbens">Quais:</label>
                                                <input type="text" v-model="voutrosbens" v-bind:disabled="bpossuibens"
                                                    class="form-control form-control-sm" id="edoutrosbens" maxlength="50"
                                                    style="text-transform: uppercase;">
                                            </div>                                                                                       
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbpossuioutroscred">Outros créditos:</label>
                                                <select class="form-control form-control-sm" id="cbpossuioutroscred" v-model="wt_possuioutroscred"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0">Não</option>
                                                    <option value="1">Sim</option>
                                                </select>
                                            </div>  
                                            <div class="col-sm-12 col-md-10 col-lg-10">
                                                <label for="edoutroscred">Quais:</label>
                                                <input type="text" v-model="voutroscred" v-bind:disabled="bpossuioutroscred"
                                                    class="form-control form-control-sm" id="edoutroscred" maxlength="50"
                                                    style="text-transform: uppercase;">
                                            </div>                                                                                       
                                        </div>                                        
                                    </div>
                                    <!-- FIM TRABALHO E RENDA -->  

                                    <!-- DADOS DO CONJUGE -->
                                    <div class="tab-pane container-fluid" id="dvconjuge" role="tabpanel" aria-labelledby="conjuge-tab">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="ednomeconjuge">Nome:</label>
                                                <input type="text" v-model="vnomeconjuge" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="ednomeconjuge" maxlength="50"
                                                    style="text-transform: uppercase;">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edcpfconjuge">Cpf:</label>
                                                <input type="text" v-model="vcpfconjuge" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edcpfconjuge" 
                                                    v-mask="'###.###.###-##'">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edrgconjuge">Rg:</label>
                                                <input type="text" v-model="vrgconjuge" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edrgconjuge" maxlength="20">
                                            </div>                                           
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddtnascconjuge">Data Nascimento:</label>
                                                <date-picker id="eddtnascconjuge" v-model="vdtnascconjuge" :config="options" 
                                                    class="form-control form-control-sm" v-bind:disabled="ativadesativa"></date-picker>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edrendasalconjuge">Renda salarial:</label>
                                                <money class="form-control form-control-sm" id="edrendasalconjuge" v-bind="money" v-model="vrendasalconjuge"
                                                    value="0,00" data-bv-group=".group" v-bind:disabled="ativadesativa"
                                                    style="text-align:right;"></money>
                                            </div> 
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edrendaextraconjuge">Renda extra:</label>
                                                <money class="form-control form-control-sm" id="edrendaextraconjuge" v-bind="money" v-model="vrendaextraconjuge"
                                                    value="0,00" data-bv-group=".group" v-bind:disabled="ativadesativa"
                                                    style="text-align:right;"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edpaiconjuge">Pai:</label>
                                                <input type="text" v-model="vpaiconjuge" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edpaiconjuge" maxlength="50"
                                                    style="text-transform: uppercase;">
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edmaeconjuge">Mãe:</label>
                                                <input type="text" v-model="vmaeconjuge" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edmaeconjuge" maxlength="50"
                                                    style="text-transform: uppercase;">
                                            </div>                                                                                                                                                                                                                                                                       
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="edlocaltrabconjuge">Local de trabalho:</label>
                                                <input type="text" v-model="vlocaltrabconjuge" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edlocaltrabconjuge" maxlength="100"
                                                    style="text-transform: uppercase;">
                                            </div>
                                            <div class="col-sm-12 col-md-4 col-lg-4">
                                                <label for="edtpservicoconjuge">Tipo de serviço:</label>
                                                <input type="text" v-model="vtpservicoconjuge" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edtpservicoconjuge" maxlength="100"
                                                    style="text-transform: uppercase;">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edfonetrabconjuge">Fone:</label>
                                                <input type="text" v-model="vfonetrabconjuge" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edfonetrabconjuge" 
                                                    v-mask="['(##) ####-####', '(##) #####-####']">
                                            </div>
                                        </div>
                                    </div>
                                    <!-- FIM DADOS DO CONJUGE -->

                                    <!-- FIADOR E REFERENCIA -->
                                    <div class="tab-pane container-fluid" id="dvfiadorref" role="tabpanel" aria-labelledby="fiadorref-tab">
                                        <div class="card">
                                            <div class="card-header">
                                                Dados do Fiador
                                            </div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-sm-12 col-md-8 col-lg-8">
                                                        <label for="ednomefiador">Nome:</label>
                                                        <input type="text" v-model="vnomefiador" v-bind:disabled="ativadesativa"
                                                            class="form-control form-control-sm" id="ednomefiador" maxlength="50"
                                                            style="text-transform: uppercase;">
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edcpffiador">Cpf:</label>
                                                        <input type="text" v-model="vcpffiador" v-bind:disabled="ativadesativa"
                                                            class="form-control form-control-sm" id="edcpffiador" 
                                                            v-mask="'###.###.###-##'">
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edrgfiador">Rg:</label>
                                                        <input type="text" v-model="vrgfiador" v-bind:disabled="ativadesativa"
                                                            class="form-control form-control-sm" id="edrgfiador" maxlength="20">
                                                    </div>
                                                </div>

                                                <div class="row">
                                                    <div class="col-sm-12 col-md-10 col-lg-10">
                                                        <label for="edendfiador">Endereço:</label>
                                                        <input type="text" v-model="vendfiador" v-bind:disabled="ativadesativa"
                                                            class="form-control form-control-sm" id="edendfiador" maxlength="100"
                                                            style="text-transform: uppercase;">
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edfonefiador">Fone:</label>
                                                        <input type="text" v-model="vfonefiador" v-bind:disabled="ativadesativa"
                                                            class="form-control form-control-sm" id="edfonefiador" 
                                                            v-mask="['(##) ####-####', '(##) #####-####']">
                                                    </div>                                                                                                                                                
                                                </div>
                                            </div>
                                        </div>

                                        <div class="card" style="margin-top: 10px;">
                                            <div class="card-header">
                                                Dados da Referência
                                            </div>
                                            <div class="card-body">
                                                <div class="row">
                                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                                        <label for="ednomeref1">Nome:</label>
                                                        <input type="text" v-model="vnomeref1" v-bind:disabled="ativadesativa"
                                                            class="form-control form-control-sm" id="ednomeref1" maxlength="50"
                                                            style="text-transform: uppercase;">
                                                    </div>
                                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                                        <label for="edenderecoref1">Endereço:</label>
                                                        <input type="text" v-model="venderecoref1" v-bind:disabled="ativadesativa"
                                                            class="form-control form-control-sm" id="edenderecoref1" maxlength="100"
                                                            style="text-transform: uppercase;">
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edfoneref1">Fone:</label>
                                                        <input type="text" v-model="vfoneref1" v-bind:disabled="ativadesativa"
                                                            class="form-control form-control-sm" id="edfoneref1" 
                                                            v-mask="['(##) ####-####', '(##) #####-####']">
                                                    </div>                                                                                                
                                                </div>

                                                <div class="row">
                                                    <div class="col-sm-12 col-md-4 col-lg-4">
                                                        <label for="ednomeref2">Nome:</label>
                                                        <input type="text" v-model="vnomeref2" v-bind:disabled="ativadesativa"
                                                            class="form-control form-control-sm" id="ednomeref2" maxlength="50"
                                                            style="text-transform: uppercase;">
                                                    </div>
                                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                                        <label for="edenderecoref2">Endereço:</label>
                                                        <input type="text" v-model="venderecoref2" v-bind:disabled="ativadesativa"
                                                            class="form-control form-control-sm" id="edenderecoref2" maxlength="100"
                                                            style="text-transform: uppercase;">
                                                    </div>
                                                    <div class="col-sm-12 col-md-2 col-lg-2">
                                                        <label for="edfoneref2">Fone:</label>
                                                        <input type="text" v-model="vfoneref2" v-bind:disabled="ativadesativa"
                                                            class="form-control form-control-sm" id="edfoneref2" 
                                                            v-mask="['(##) ####-####', '(##) #####-####']">
                                                    </div>                                                                                                
                                                </div>
                                            </div>
                                        </div>                                        
                                    </div>
                                    <!-- FIM FIADOR E REFERENCIA -->

                                    <!-- CRÉDITO -->
                                    <div class="tab-pane container-fluid" id="dvcredito" role="tabpanel" aria-labelledby="credito-tab">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edvlcredito">Limite crédito:</label>
                                                <money class="form-control form-control-sm" id="edvlcredito" v-bind="money" v-model="vvlcredito"
                                                    value="0,00" data-bv-group=".group" v-bind:disabled="ativadesativa"
                                                    style="text-align:right;"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edvlcreditosuple">Créd. Suplementar:</label>
                                                <money class="form-control form-control-sm" id="edvlcreditosuple" v-bind="money" v-model="vvlcreditosuple"
                                                    value="0,00" data-bv-group=".group" v-bind:disabled="ativadesativa"
                                                    style="text-align:right;"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edqtddiasbloqvenda">Dias bloq. Venda:</label>
                                                <input type="number" v-model="vqtddiasbloqvenda" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edqtddiasbloqvenda" min="0">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edqtddiastolatraso">Dias atraso:</label>
                                                <input type="number" v-model="vqtddiastolatraso" v-bind:disabled="ativadesativa"
                                                    class="form-control form-control-sm" id="edqtddiastolatraso" min="0">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edvlmetames">Meta mensal:</label>
                                                <money class="form-control form-control-sm" id="edvlmetames" v-bind="money" v-model="vvlmetames"
                                                    value="0,00" data-bv-group=".group" v-bind:disabled="ativadesativa"
                                                    style="text-align:right;"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbcobrartx">Cobrar taxas:</label>
                                                <select class="form-control form-control-sm" id="cbcobrartx" v-model="vcobrartx"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0">Sim</option>
                                                    <option value="1">Não</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbtipovencimento">Tp. Vencimento:</label>
                                                <select class="form-control form-control-sm" id="cbtipovencimento" v-model="wt_tipovencimento"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0">Intervalo</option>
                                                    <option value="1">Fixo</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddiavencimento">Dia vencimento:</label>
                                                <input type="number" v-model="vdiavencimento" v-bind:disabled="btipovencimento"
                                                    class="form-control form-control-sm" id="eddiavencimento" min="1" max="31">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="eddiascarencia">Dia de carência:</label>
                                                <input type="number" v-model="vdiascarencia" v-bind:disabled="btipovencimento"
                                                    class="form-control form-control-sm" id="eddiascarencia" min="0">
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbexigirentrada">Exigir entrada:</label>
                                                <select class="form-control form-control-sm" id="cbexigirentrada" v-model="wt_exigirentrada"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0">Não</option>
                                                    <option value="1">Sim</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="edpercentrada">Perc. Entrada:</label>
                                                <money class="form-control form-control-sm" id="edpercentrada" v-bind="money" v-model="vpercentrada"
                                                    value="0,00" data-bv-group=".group" v-bind:disabled="bexigirentrada"
                                                    style="text-align:right;"></money>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbutilizacusto">Utiliza custo:</label>
                                                <select class="form-control form-control-sm" id="cbutilizacusto" v-model="vutilizacusto"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0">Não</option>
                                                    <option value="1">Sim</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-sm-12 col-md-2 col-lg-2">
                                                <label for="cbrestringe">Restringir:</label>
                                                <select class="form-control form-control-sm" id="cbrestringe" v-model="wt_restringeCli"
                                                        v-bind:disabled="ativadesativa">
                                                    <option value="0">Não</option>
                                                    <option value="1">Sim</option>
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-10 col-lg-10">
                                                <label for="edmotivorestricao">Motivo:</label>
                                                <input type="text" v-model="vmotivorestricao" v-bind:disabled="bmotivoRestringe"
                                                    class="form-control form-control-sm" id="edmotivorestricao" maxlength="100"
                                                    style="text-transform: uppercase;">
                                            </div>
                                        </div>
                                    </div>
                                    <!-- FIM CRÉDITO -->

                                    <!-- PLANOS DE PAGAMENTO -->
                                    <div class="tab-pane container-fluid" id="dvplanospagamento" role="tabpanel" aria-labelledby="planospagamento-tab">
                                        <div class="row">
                                            <div class="col-sm-12 col-md-6 col-lg-6">
                                                <label for="cbplanopagamento">Plano de pagamento:</label>
                                                <select id="cbplanopagamento" data-placeholder="Selecione um plano" data-allow-clear="true"
                                                        style="width:100%;" v-model="vidplano" v-bind:disabled="ativadesativa">
                                                </select>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 21px;">
                                                <button v-bind:disabled="ativadesativa" type="button" id="btinplano" @click.prevent="mtdincluiplanos()" class="btn btn-success btn-sm" style="width:100%"><i class="fa fa-plus-circle"></i> Incluir</button>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 21px;">
                                                <button v-bind:disabled="ativadesativa" type="button" id="btinctodosplanos" @click.prevent="mtdincluirtodosplano()" class="btn btn-success btn-sm" style="width:100%"><i class="fa fa-refresh"></i> Incluir todos</button>
                                            </div>
                                            <div class="col-sm-12 col-md-2 col-lg-2" style="padding-top: 21px;">
                                                <button v-bind:disabled="ativadesativa" type="button" id="btexctodosplanos" @click.prevent="mtdexcluirtodosplanos()" class="btn btn-success btn-sm" style="width:100%"><i class="fa fa-trash"></i> Remover todos</button>
                                            </div>                                                                                        
                                            <div class="col-sm-12 col-md-12 col-lg-12" style="padding-top: 15px;">
                                                <div class="list-group">                                                    
                                                    <a v-for="planospagamento in lstplanospagamento" v-bind:key="planospagamento.id" href="#" @click.prevent="" class="list-group-item list-group-item-action">
                                                        <button v-if="parseInt(opcrud) < 3" type="button" class="close" aria-label="Remover" @click.prevent="mtdexcluirplano(planospagamento)">
                                                            <span aria-hidden="true"><i class="fa fa-trash excplanos"></i></span>
                                                        </button>
                                                        <span class="titplanos">{{ mtdformatarzeros(planospagamento.id, 2) }} - {{ planospagamento.descricao }}</span>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- FIM PLANOS DE PAGAMENTO -->

                                    <!-- ANOTAÇÕES -->
                                    <div class="tab-pane container-fluid" id="dvobservacoes" role="tabpanel" aria-labelledby="observacoes-tab">
                                        <div class="form-group">
                                            <textarea class="form-control" v-bind:disabled="ativadesativa" rows="8" id="edobservacoes" v-model="vobservacoes"></textarea>
                                        </div>                                            
                                    </div>
                                    <!-- FIM ANOTAÇÕES -->
                                </div>
                            </div>
                        </div>

                    </div>                    
                    <div class="card-footer">
                        <div class="row">
                            <div class="col-sm-8">
                                <h5 style="font-size: 16px; color: #545b62; margin-top: 5px;"><strong>Campos obrigatórios são sinalizados com \*</strong>.</h5>
                            </div>
                            <div class="col-sm-2">
                                <button id="btgravar" v-if="(opcrud == 1)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Salvar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 2)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Editar
                                </button>
                                <button id="btgravar" v-else-if="(opcrud == 3)" type="button" @click.prevent="mtdgravar()"
                                        v-bind:disabled="validou" class="btn btn-primary btn-sm"
                                        style="width:100%; margin-bottom:10px;"><i class="fa fa-check"></i> Remover
                                </button>
                            </div>
                            <div class="col-sm-2">
                                <button type="button" @click.prevent="mtdcancelaredicao()" class="btn btn-secondary btn-sm" style="width:100%">
                                    <i class="fa fa-close"></i> Fechar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <div id="pnimportacao" class="card" style="display: none;">
                    <div class="card-header"><span id="titlista">CENTRAL DE IMPORTAÇÃO DE CLIENTES</span>                        
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click.prevent="mtdcancelaredicao()"><span aria-hidden="true">&times;</span></button>
                    </div>
                    <div class="card-body" style="padding: 30px;">
                        <div class="row">
                                <div class="col-md-12" style="padding-bottom: 15px!important;">
                                    <h1 style="color: #0acf97!important;" class="text-info">CENTRAL DE IMPORTAÇÃO</h1>
                                </div>
                                <div class="col-md-12">
                                    <p style="text-indent: 1.5em; font-size: 14px; color: #666;">
                                        Para este procedimento uma matriz de arquivo no formato do EXCEL(.xls) está disponibilizada para download. Basta clicar no link a baixo para baixá-la.
                                        Preencha a mesma com os dados corretamente, sem alterar as posições das colunas.
                                        Após o preenchimento, salve os dados e clique em "Enviar arquivo". Aguarde o processamento, ao final o sistema irá listar o resultado da importação.</p>
                                    <p style="font-size: 14px; color: #666; margin-left: 50px;">
                                        Campos de CNPJ, telefone, CEP, devem ser informados somente os números, sem formatação;<br>
                                        Campo de Data deve ser informados no formato dd/mm/aaaa, sendo que os mesmos devem estar formatados como texto no EXCEL (utilize a fórmula <strong>=TEXTO(A1; "dd/mm/aaaa")</strong>, em seguida copiar e colar especial).<br>
                                    </p>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div class="custom-control custom-checkbox chbajuste">
                                        <input type="checkbox" class="custom-control-input" id="cblimpardados" v-model="vlimpardados">
                                        <label class="custom-control-label" for="cblimpardados" style="color: #f82b54;">Limpar cadastro existente</label>
                                    </div>
                                </div>
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div class="custom-control custom-checkbox chbajuste">
                                        <input type="checkbox" class="custom-control-input" id="cbimportarcodigos" v-model="vimportarcodigos">
                                        <label class="custom-control-label" for="cbimportarcodigos" style="color: #f82b54;">Manter códigos</label>
                                    </div>
                                </div>                                                             
                                <div class="col-sm-12 col-md-12 col-lg-12">
                                    <div class="custom-control custom-checkbox chbajuste">
                                        <input type="checkbox" class="custom-control-input" id="cbadicionaraocadastro" v-model="vadicionaraocadastro" v-bind:visible="!vlimpardados">
                                        <label class="custom-control-label" for="cbadicionaraocadastro" style="color: #f82b54;">Adicionar ao cadastro existente</label>
                                    </div>
                                </div>                                                                     
                                <div class="col-md-8">
                                    <input type="file" id="btselecionararqenviar" accept=".xls" style="display: none;">
                                </div>
                                <div class="col-md-2">
                                    <button type="button" class="btn btn-green" @click.prevent="mtdbaixarmatriz()" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;">
                                        <img src="@/assets/matrizexcel.png">
                                        Baixar matriz
                                    </button>
                                </div>
                                <div class="col-md-2">
                                    <input
                                        type="file" 
                                        id="ipselecionararquivo"
                                        accept=".xls" 
                                        @change="mtdselecionararquivo" 
                                        style="display: none;"
                                        ref="if_selecionarquivo">                                    
                                    <button type="button" @click="$refs.if_selecionarquivo.click()" class="btn btn-blue" style="width: 100%; margin-bottom: 10px; min-height: 75px; margin-top: 10px;"><i class="fa fa-upload"></i>
                                        Enviar arquivo
                                    </button>
                                </div>
                        </div>
                    </div>
                    <div class="card-footer" style="padding: 10px;">
                        <div class="row">
                            <div class="col-8 col-sm-8 col-md-10 col-lg-10">
                            </div>
                            <div class="col-4 col-sm-4 col-md-2 col-lg-2">
                                <button type="button" class="btn btn-secondary btn-sm btn-block" @click.prevent="mtdcancelaredicao()"><i class="fa fa-close"></i> Fechar</button>
                            </div>
                        </div>
                    </div>                                        
                </div>
            </div>
        </div>

        <!-- Modal para aplicação de plano de pagamento --> 
        <div class="modal fade" id="mdatribuirplano" tabindex="-1">
            <div class="modal-dialog modal-dialog-centered">
                <div class="modal-content">                        
                    <div class="modal-header">
                        <i class="fa fa-user-plus" style="margin-top: 8px; margin-right: 7px"></i><h4 class="modal-title" style="color: #fff;">Atribuir/Remover Planos de Pagamento</h4>
                        <button type="button" class="close" data-dismiss="modal">&times;</button>
                    </div>                
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-sm-12 col-md-4 col-lg-4">
                                <label for="cbopcao">Opção:</label>
                                <select name="cbopcao" class="form-control form-control-sm" id="cbopcaoclasse" v-model="vopcaoplanoatribuir">
                                    <option value="0">Atribuir</option>
                                    <option value="1">Remover</option>
                                </select>
                            </div>                                                                                                                   
                            <div class="col-md-12" id="ex-dvclasseatribuir">
                                <!-- <span class="lblselect2">Plano:</span>
                                <select id="cbplanoatribuir" data-placeholder="Selecione uma opção"
                                    v-model="vidplanoatribuir"
                                    data-allow-clear="true" style="width:100%;">
                                </select> -->

                                <table class="table table-striped table-sm">
                                    <thead>
                                        <tr>
                                        <th scope="col"><i @click.prevent="mtdmarcartodas()" class="fa fa-plus-square" aria-hidden="true" style="cursor: pointer;"></i></th>
                                        <th scope="col"><strong>Plano</strong></th>
                                        </tr>
                                    </thead>
                                    <tbody v-for="(planospagamento, index) in lstplanosatribuir" :key="planospagamento.index">
                                        <tr>
                                        <td @click.prevent="mtdhabilita(index)">
                                            <i v-if="planospagamento.marcado===1"  class="fa fa-check-square-o" aria-hidden="true" style="cursor: pointer;"></i> 
                                            <i v-else class="fa fa-square-o"  aria-hidden="true" style="cursor: pointer;"></i> 
                                        </td>
                                        <td>{{planospagamento.descricao}}</td>
                                        </tr>                                              
                                    </tbody>
                                </table>
                            </div>
                            <div class="col-md-12" style="padding-top: 10px; padding-bottom: 15px;">
                                <div class="custom-control custom-switch" style="position: absolute; left: 15px;">
                                    <input type="checkbox" class="custom-control-input" id="swctodosprodutos" name="swctodosprodutos" v-model="vatribuitodoscli">
                                    <label class="custom-control-label" for="swctodosprodutos">Aplicar a todos os clientes</label>
                                </div>                                
                            </div>
                        </div>
                    </div>                                            
                    <div class="modal-footer">
                        <button id="btconfirmar" type="button" @click.prevent="mtdaplicaselecao()" class="btn btn-primary btn-sm"><i class="fa fa-check"></i> Confirmar</button>                        
                        <button type="button" class="btn btn-secondary btn-sm" data-dismiss="modal"><i class="fa fa-close"></i> Fechar</button>
                    </div>                          
                </div>
            </div>
        </div>        
    </div>
</template>
<script>
    import BreadCrumb from '../components/cmpbreadcrumb.vue'
    import VueBootstrap4Table from 'vue-bootstrap4-table'
    import vPagination from 'vue-plain-pagination'
    import Swal from "sweetalert2/dist/sweetalert2.js"
    import "sweetalert2/dist/sweetalert2.min.css"
    import util from '../utilitarios/util.js'

    export default {
        name: 'cadclientes',
        components:{
            VueBootstrap4Table,
            vPagination,
            'breadcrumb' : BreadCrumb
        },
        data: function() {
            return {
                lstclientes          : [],
                pfiltro              :  1,
                pconteudo            : '',
                ptipopessoa          : 3,
                pqtdregistros        : 10,
                psituacao            :  0,
                pidmunicipio         : null,
                pidvendedor          : null,
                pidcategoria         : null,
                pidrota              : null,
                pqtd_paginas         :  1,
                pagina_atual         :  1,
                pqtd_total_registros :  0,

                pmaisfiltros : false,
                pdtini       : util.DataAtual(true),
				pdtfim       : util.DataAtual(true),                

                //Data do cadastro
                vdtcadastro          : util.DataAtual(true),

                options: {
                    format           : 'DD/MM/YYYY',
                    useCurrent       : false,
                    locale           : 'pt-BR'
                },
                money: {
                    decimal          : ',',
                    thousands        : '.',
                    prefix           : '',
                    precision        : 2,
                    masked           : false
                },                                

                //variáveis do crud
                opcrud               :  0,
                vid                  : '',
                vreg                 :  0,
                vtipopessoa          :  0,
                vtipocontribuinte    :  9,
                vsituacao            :  0,                
                vnrcartao            : '',
                vnome                : '',
                vfantasia            : '',
                vavulso              : 0,

                //Variaveis endereço
                vcep                 : '',
                vlogradouro          : '',
                vnrendereco          : '',
                vcomplementoend      : '',
                vperimetroend        : '', 
                vidbairro            : null,
                vidmunicipio         : null,
                viduf                : '',
                vidcategoria         : null, 
                vidrota              : null,

                //Variaveis principal
                vcnpjcpf             : '',
                vrginsc              : '',
                viepf                : '',   
                vinscsuframa         : '',
                videstrangeiro       : '',
                vinscricaomunicipal  : '',
                vdtnascfund          : null,
                vcarteiraprof        : '', 
                vqtddependentes      :  0, 
                vestadocivil         :  0,
                vnacionalidade       : '',
                vnaturalidade        : '',
                vsexo                :  0,
                vresidencia          :  5,
                vvlaluguel           :  0,
                vfone1               : '',
                vfone2               : '',
                vfone3               : '', 
                vcelular             : '',
                vcontato             : '',  
                vemail               : '',
                vsite                : '',
                vnomepai             : '',
                vnomemae             : '',
                
                //Variaveis trab/renda
                vlocaltrab           : '',
                vtiposervico         : '',
                vcargotrab           : '',
                vrendasalarial       :  0,
                vrendaextra          :  0,
                venderecotrab        : '',
                vfonetrab            : '',
                vpossuibens          :  0,
                voutrosbens          : '',
                vpossuioutroscred    :  0,
                voutroscred          : '',  

                //Variaveis do cônjuge
                vnomeconjuge         : '',
                vcpfconjuge          : '',
                vrgconjuge           : '', 
                vdtnascconjuge       : null,
                vpaiconjuge          : '',
                vmaeconjuge          : '',
                vlocaltrabconjuge    : '',
                vtpservicoconjuge    : '',
                vfonetrabconjuge     : '',
                vrendasalconjuge     : '',
                vrendaextraconjuge   :  0,

                //Variaveis fiador/referencia
                vnomefiador          : '',
                vcpffiador           : '',
                vrgfiador            : '',
                vendfiador           : '',
                vfonefiador          : '',
                vnomeref1            : '',
                venderecoref1        : '',
                vfoneref1            : '', 
                vnomeref2            : '',
                venderecoref2        : '',
                vfoneref2            : '', 

                //Variaveis crédito
                vvlcredito           :  0,
                vvlcreditosuple      :  0,
                vqtddiasbloqvenda    :  0,
                vqtddiastolatraso    :  0,
                vvlmetames           :  0,
                vcobrartx            :  0,
                vtipovencimento      :  0,
                vdiavencimento       :  1,
                vdiascarencia        :  0,
                vexigirentrada       :  0,
                vpercentrada         :  0,
                vutilizacusto        :  0,
                vrestringe           :  0,
                vmotivorestricao     : '',
                vdiretorioimagem     : '',
                vimagemcliente       : '',

                //pega o path do diretorio padrão das imagens
                pathimgview         : this.$store.state.configpaths.pathimagens,

                //path com o caminho pronto da imagem para visualização
                pathimagemvisualizar: '',                

                //Variaveis planos de pagamento
                vidplano             : null,
                lstplanospagamento   : [],

                vobservacoes         : '',
                vidfilial            : null,
                vidvendedor          : null,

                //Variáveis para habilitação dos campos
                ativadesativa        : true,
                wt_restringeCli      :  0,
                wt_possuibens        :  0,
                wt_possuioutroscred  :  0,
                wt_tipovencimento    :  0, 
                wt_residencia        :  0,
                wt_restringeCli      :  0,
                wt_exigirentrada     :  0,

                labelCustoCasa       : '',
                bativaCustoCasa      : false,
                bmotivoRestringe     : true,
                bpossuibens          : true, 
                bpossuioutroscred    : true,
                btipovencimento      : true,
                bexigirentrada       : true,

                //variavels para modal atribuir plano
                vidplanoatribuir     : null,
                vopcaoplanoatribuir  : 0,
                vatribuitodoscli     : false, 
                lstplanosatribuir    : [],
                lstplanosselec       : [],


                //variável da importação
                vlimpardados            : false,
                vadicionaraocadastro    : false,
                arqselecionado          : null,
                vimportarcodigos        : false,
                ////////////////////////////////
                
                //variáveis para exportação para o excel
                //caso queira exportar todo o conteúdo não informar o json_fields na declaração do componente
                json_fields: {
                            'Código'      : 'id',
                            'Nome'        : 'nome',
                            'Fantasia'    : 'fantasia',
                            'CPF/CNPJ'    : 'cnpjcpf',
                            'RG/IE'       : 'rginsc',
                            'Data Cadastro': 'dtcadastro',
                            'CEP'         : 'cep',
                            'Logradouro'  : 'logradouro',
                            'Nr.:'        : 'nrendereco',
                            'Bairro'      : 'descbairro',
                            'Município'   : 'descmunic',
                            'UF'          : 'iduf',
                            'Complemento' : 'complementoend',
                            'Fone'        : 'fone1',
                            'E-mail'      : 'email'  
                },
                json_meta: [
                    [
                        {
                            'key': 'charset',
                            'value': 'utf-8'
                        }
                    ]
                ],                
                ///////////////////////////////
                bootstrapPaginationClasses: {
                    ul: 'pagination pagination-sm',
                    li: 'page-item',
                    liActive: 'active',
                    liDisable: 'disabled',
                    button: 'page-link'
                },
                itensbc : {
                    item1 : {
                        titulo : 'CLIENTES',
                        ativo  : false
                    },
                    item2 : {
                        titulo : '',
                        ativo  : false
                    }
                },
                columns: [
                    {
                        label: 'Opções',
                        name : 'opcoes',
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        row_classes: "def-col-opcoes",
                        sort: false
                    },
                    {
                        label: "Código",
                        name: "id",
                        sort: true,
                        slot_name: "id_f",
                        row_classes: "def-col-cod",
                    },
                    {
                        label: "Situação",
                        name: "ativo",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "ativo_f",
                        row_classes: "def-col-ativo"
                    },
                    {
                        label: "Pessoa",
                        name: "tipopessoa",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-center",
                        column_text_alignment: "text-center",
                        slot_name: "slot_tipopessoa",
                        row_classes: "def-col-tipopessoa"
                    },                    
                    {
                        label: "Razão Social",
                        name: "nome",
                        initial_sort : true,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Fantasia",
                        name: "fantasia",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Fone",
                        name: "fone1",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "fone_f",
                        row_classes: "def-col-fone"
                    },
                    {
                        label: "CNPJ/CPF",
                        name: "cnpjcpf",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left",
                        slot_name: "cnpjcpf_f",
                        row_classes: "def-col-cnpjcpf"
                    },
                    {
                        label: "E-mail",
                        name: "email",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    },
                    {
                        label: "Município",
                        name: "descmunic",
                        initial_sort : false,
                        initial_sort_order: 'asc',
                        sort: true,
                        row_text_alignment: "text-left",
                        column_text_alignment: "text-left"
                    }                                        
                ],
                config: {
                    pagination: false,
                    pagination_info: false,
                    card_mode: false,
                    checkbox_rows: true,
                    global_search: {
                        visibility: false,
                    },
                    show_refresh_button : false,
                    show_reset_button : false
                },
                classes: {
                    table: "table-bordered table-striped table-sm"
                }
            }
        },
        methods:{
			mtdformatarzeros(str, length){
				return util.formatarzeros(str, length);
			},            
            mtdformatafone(fone){
				return util.formatarfone(fone);
			},
            mtdselecionarimagemcliente(event){                
                let vself = this;                 
                vself.arqimgselecionado = event.target.files[0];
                let loader      = vself.$loading.show();
                let localsalvar = vself.$store.state.configpaths.pathimgclientes + vself.$store.state.filialpadrao.idcliente+'/'+vself.vdiretorioimagem;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqimgselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqimgselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.vimagemcliente       = localsalvar+'/'+vself.arqimgselecionado.name;                        
                        vself.arqimgselecionado    = null;
                        vself.pathimagemvisualizar = vself.pathimgview+vself.vimagemcliente;
                        util.notif("success", 'Imagem enviada com sucesso!')
                        $('#ipselecionarimgcliente').val('');
                    }else{
                        vself.vimagemcliente    = '';                        
                        vself.arqimgselecionado = null;
                        $('#ipselecionarimgcliente').val('');
                        util.notif("error", 'Descrição do erro: '+response.data)
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    util.notif("error", 'Descrição do erro: '+response.message)
                    vself.vimagemcliente             = '';                        
                    vself.arqimgselecionado = null;
                    $('#ipselecionarimgcliente').val('');
                });                
            },
            mtdexcluirimgcliente(){
                let vself = this;
                if (!util.contemstring(vself.pathimagemvisualizar, 'semimagem')){                    
                    let loader       = vself.$loading.show();
                    let localarquivo = vself.$store.state.configpaths.pathimgclientes + 
                                    vself.$store.state.filialpadrao.idcliente +'/'+
                                    vself.vdiretorioimagem;

                    let parametros      = [
                        {parametro: 'op',               valor  : "excluirarquivo"},
                        {parametro: 'patharquivo',      valor  : vself.vimagemcliente},
                        {parametro: 'localarquivo',     valor  : localarquivo}
                        
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/auxiliares.php');
                    retorno.then(function (response) {
                        if ($.isNumeric(response.data.inf)){
                            util.notif("success", 'Registro processado com sucesso!')
                            vself.vimagemcliente = '';
                            vself.pathimagemvisualizar = vself.$store.state.configpaths.pathimagens+'imagens/semimagem.png';
                        }else{                        
                            util.notif("error", 'Descrição do erro: '+response.data)
                        }
                        loader.hide();
                    }).catch(function (response) {
                        loader.hide();
                        util.notif("error", 'Descrição do erro: '+response.message)
                    });                  
                }
            },                        
            mtdfiltropesquisa(){
                let rfiltro = '';

                switch (parseInt(this.pfiltro)) {
                    case 0:
                        rfiltro = this.pconteudo === '' ? '' : ' and c.id='+this.pconteudo;
                        break;
                    case 1:
                        rfiltro = this.pconteudo === '' ? '' : ' and upper(c.nome) like upper(\''+this.pconteudo+'%\')';
                        break;
                    case 2:
                        rfiltro = this.pconteudo === '' ? '' : ' and upper(c.fantasia) like upper(\''+this.pconteudo+'%\')';
                        break;  
                    case 3:
                        rfiltro = this.pconteudo === '' ? '' : ' and upper(c.cnpjcpf) like upper(\''+this.pconteudo+'%\')';
                        break; 
                    case 4:
                        rfiltro = this.pconteudo === '' ? '' : ' and upper(c.rginsc) like upper(\''+this.pconteudo+'%\')';
                        break;     
                    case 5:
                        rfiltro = this.pconteudo === '' ? '' : ' and upper(c.nrcartao) like upper(\''+this.pconteudo+'%\')';
                        break;  
                    case 6:
                        rfiltro = this.pconteudo === '' ? '' : ' and upper(c.fone1) like upper(\''+this.pconteudo+'%\')';
                        break; 
                    case 7:
                        rfiltro = this.pconteudo === '' ? '' : ' and upper(c.fone2) like upper(\''+this.pconteudo+'%\')';
                        break;                                                                                                                                            
                }

                switch (parseInt(this.psituacao)) {
                    case 0:
                        rfiltro = rfiltro + ' and c.ativo=0';
                        break;
                    case 1:
                        rfiltro = rfiltro + ' and c.ativo=1';
                        break;                   
                } 

                if (parseInt(this.ptipopessoa) < 3){
                    rfiltro = rfiltro + ' and c.tipopessoa='+this.ptipopessoa;
                }

                if (this.pidmunicipio !== null){
                    rfiltro = rfiltro + ' and c.idmunicipio='+this.pidmunicipio;
                }

                if (this.pidvendedor !== null){
                    rfiltro = rfiltro + ' and c.idvendedor='+this.pidvendedor;
                }

                if (this.pidcategoria !== null){
                    rfiltro = rfiltro + ' and c.idcategoria='+this.pidcategoria;
                }      
                
                if (this.pidrota !== null){
                    rfiltro = rfiltro + ' and c.idrota='+this.pidrota;
                } 
                
                if (this.pmaisfiltros){
                    if (parseInt(this.pfiltroadquiridospesq) === 1){
                        rfiltro = rfiltro + ' and c.dtcadastro between "' + util.InverterData(this.pdtini) + ' 00:00:00" and "' + util.InverterData(this.pdtfim) + ' 23:59:59"';               
                    }
                }                

                return rfiltro;
            },
            mtdexecutapesquisa(){
                var vself           = this;
                let filtro          = vself.mtdfiltropesquisa();
                this.pagina_atual   = 1;
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor  : 'qtdregistros'},
                    {parametro: 'filtro',       valor  : filtro}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
                retorno.then(function (response) {
                    vself.pqtd_total_registros = parseInt(response.data.qtdregistros);
                    let qtdpg                  = Math.ceil(vself.pqtd_total_registros / vself.pqtdregistros);
                    vself.pqtd_paginas         = qtdpg > 0 ? qtdpg : 1;
                    vself.mtdcarregaclientes(1);
                }).catch(function (response) {
                    alert('Erro ao consultar registros');
                });
            },
            mtdcarregaclientes(ipagina){
                var vself       = this;
                let loader      = this.$loading.show();
                let filtro      = vself.mtdfiltropesquisa();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : vself.pqtdregistros},
                    {parametro: 'offset',       valor : (parseInt(ipagina) -1) * parseInt(vself.pqtdregistros)},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
                retorno.then(function (response) {
                    vself.lstclientes = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstclientes = [];
                    loader.hide();
                });
            },
            resetarDados() {
                util.toTop();

                //Data do cadastro
                this.vdtcadastro          = util.DataAtual(true);

                this.vid                  = '';
                this.vtipopessoa          =  0;
                this.vreg                 =  0;
                this.vtipocontribuinte    =  9;
                this.vsituacao            =  0;                
                this.vnrcartao            = '';
                this.vnome                = '';
                this.vfantasia            = '';
                this.vavulso              = 0;

                //Variaveis endereço
                this.vcep                 = '';
                this.vlogradouro          = '';
                this.vnrendereco          = '';
                this.vcomplementoend      = '';
                this.vperimetroend        = ''; 
                this.vidbairro            = null;
                this.vidmunicipio         = null;
                this.viduf                = '';
                this.vidcategoria         = null; 
                this.vidrota              = null;  

                //Variaveis principal
                this.vcnpjcpf             = '';
                this.vrginsc              = '';
                this.viepf                = '';
                this.vinscsuframa         = '';
                this.videstrangeiro       = '';
                this.vinscricaomunicipal  = '';    
                this.vdtnascfund          = null;
                this.vcarteiraprof        = ''; 
                this.vqtddependentes      =  0; 
                this.vestadocivil         =  0;
                this.vnacionalidade       = '';
                this.vnaturalidade        = '';
                this.vsexo                =  0;
                this.vresidencia          =  5;
                this.vvlaluguel           =  0;
                this.vfone1               = '';
                this.vfone2               = '';
                this.vfone3               = ''; 
                this.vcelular             = '';
                this.vcontato             = '';  
                this.vemail               = '';
                this.vsite                = '';
                this.vnomepai             = '',
                this.vnomemae             = '',                
                
                //Variaveis trab/renda
                this.vlocaltrab           = '';
                this.vtiposervico         = '';
                this.vcargotrab           = '';
                this.vrendasalarial       =  0;
                this.vrendaextra          =  0;
                this.venderecotrab        = '';
                this.vfonetrab            = '';
                this.vpossuibens          =  0;
                this.voutrosbens          = '';
                this.vpossuioutroscred    =  0;
                this.voutroscred          = '';  

                //Variaveis do cônjuge
                this.vnomeconjuge         = '';
                this.vcpfconjuge          = '';
                this.vrgconjuge           = ''; 
                this.vdtnascconjuge       = null;
                this.vpaiconjuge          = '';
                this.vmaeconjuge          = '';
                this.vlocaltrabconjuge    = '';
                this.vtpservicoconjuge    = '';
                this.vfonetrabconjuge     = '';
                this.vrendasalconjuge     = '';
                this.vrendaextraconjuge   =  0;

                //Variaveis fiador/referencia
                this.vnomefiador          = '';
                this.vcpffiador           = '';
                this.vrgfiador            = '';
                this.vendfiador           = '';
                this.vfonefiador          = '';
                this.vnomeref1            = '';
                this.venderecoref1        = '';
                this.vfoneref1            = ''; 
                this.vnomeref2            = '';
                this.venderecoref2        = '';
                this.vfoneref2            = ''; 

                //Variaveis crédito
                this.vvlcredito           =  0;
                this.vvlcreditosuple      =  0;
                this.vqtddiasbloqvenda    =  0;
                this.vqtddiastolatraso    =  0;
                this.vvlmetames           =  0;
                this.vcobrartx            =  0;
                this.vtipovencimento      =  0;
                this.vdiavencimento       =  1;
                this.vdiascarencia        =  0;
                this.vexigirentrada       =  0;
                this.vpercentrada         =  0;
                this.vutilizacusto        =  0;
                this.vrestringe           =  0;
                this.vmotivorestricao     = '';

                this.vdiretorioimagem     = "";
                this.vimagemcliente       = "";               

                //Variaveis planos de pagamento
                this.vidplano             = null;
                this.lstplanospagamento   = [];

                this.vobservacoes         = '';
                this.vidfilial            = null;
                this.vidvendedor          = null;

                //Variáveis para habilitação dos campos
                this.wt_restringeCli      =  0;
                this.wt_possuibens        =  0;
                this.wt_possuioutroscred  =  0;
                this.wt_tipovencimento    =  0;
                this.wt_residencia        =  0;
                this.wt_restringeCli      =  0;
                this.wt_exigirentrada     =  0;

                this.labelCustoCasa       = '';
                this.bativaCustoCasa      = false;
                this.bmotivoRestringe     = true;
                this.bpossuibens          = true;
                this.bpossuioutroscred    = true;
                this.btipovencimento      = true;
                this.bexigirentrada       = true;


                
                

                var deffil                = new Option(this.$store.state.filialpadrao.descfil, this.$store.state.filialpadrao.codfil, true, true);
                $('#cbfilial').append(deffil).trigger('change');
                
                $("#cbbairro").val('').trigger('change');
                $("#cbmunicipio").val('').trigger('change');
                $("#cbuf").val('').trigger('change');
                $("#cbcategoria").val(null).trigger('change');
                $("#cbrota").val(null).trigger('change');
            },
            mtddefault(){
                $('#pnlista').hide();
                this.resetarDados();
                $('#pncadastro').fadeIn(700);
                this.$nextTick(function () {
                    if (parseInt(this.opcrud) < 3) {
                        $('#cbtipopessoa').focus();
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdpreparacrud(op) {
                let vself    = this;
                vself.opcrud = op;
                $('.nav-tabs a[href="#dvendereco"]').tab('show');
                vself.mtddefault();
            },
            mtdnovo(){
                if (!util.opcaousuario('002Z.003M.001M', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    this.itensbc.item2.titulo = 'INCLUSÃO DE CLIENTES';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = false;
                    this.mtdpreparacrud(1);
                    this.vdiretorioimagem     = util.GerarStringAleatoria();
                    this.pathimagemvisualizar = this.$store.state.configpaths.pathimagens+'imagens/semimagem.png';                        
                }
            },
            mtdcancelaredicao(){
                this.itensbc.item1.ativo = false;
                this.itensbc.item2.ativo = false;
                $('#pncadastro').hide();
                $('#pnimportacao').hide();
                $('#pnlista').fadeIn(700);
                $('#edconteudopesq').focus();
                setTimeout(function(){
                    util.toTop();
                }, 200);
            },
            mtdlimpar_listagem() {
                this.lstclientes          = [];
                this.pagina_atual         = 1;
                this.filtro               = '';
                this.pqtd_total_registros = 0;
                this.pqtd_paginas         = 0;
            },
            mtdgravar(){
                let vself = this;
                if (parseInt(vself.opcrud) < 3) {
                    if (parseInt(vself.vtodasfiliais) === 0) {
                    }
                }

                if (vself.vtipopessoa == 0) {
                    if ((vself.vcnpjcpf.length < 11) || ($.trim(vself.vcnpjcpf.replace(/[^\d]+/g,'')) === '')){
                        util.notif("warning", 'CPF deve ser informado!');
                        $("#edcnpjcpf").focus();
                        return;
                    }

                    if (!util.validarCPF(vself.vcnpjcpf)){
                        util.notif("warning", "CPF informado não é válido!");
                        $("#edcnpjcpf").focus();
                        return;
                    }                       
                }else{
                    if ((vself.vcnpjcpf.length < 14) || ($.trim(vself.vcnpjcpf.replace(/[^\d]+/g,'')) === '')){
                        util.notif("warning", 'CNPJ deve ser informado!');
                        $("#edcnpjcpf").focus();
                        return;
                    }

                    if (!util.validarCNPJ(vself.vcnpjcpf)){
                        util.notif("warning", "CNPJ informado não é válido!");
                        $("#edcnpjcpf").focus();
                        return;
                    }

                    if ($.trim(vself.vrginsc.replace(/[^\d]+/g,'')) !== ''){
                        if (!util.validarIE(vself.vrginsc, vself.viduf)){
                            util.notif("warning", "Inscrição informada não é válida!");
                            $("#edrginsc").focus();
                            return;
                        }
                    }
                }
                if (parseInt(vself.vavulso) === 1 && parseInt(vself.vtipocontribuinte) !== 9){
                    util.notif("warning", "Cliente Avulso deve ser NÃO CONTRIBUINTE!");
                    $("#cbtipocontribuinte").focus();
                    return;
                }
                if (parseFloat(vself.vvlcredito) > parseFloat(vself.$store.state.usuario.limitecreditoautorizar)){
                    util.notif("warning", "O valor autorizado para atribuição de crédito para o cliente é maior que o definido para o usuário!");
                    $("#cbtipocontribuinte").focus();
                    return;
                }
                Swal.fire({
                    customClass: {
                        confirmButton: "btn btn-success conf",
                        cancelButton: "btn btn-danger"
                    },
                    title: "Confirmação",
                    text: 'Confirma ' + vself.itensbc.item2.titulo + '?',
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Fechar"
                }).then((result) => {
                    if (result.isConfirmed) {
                        vself.mtdregistro();
                        $('.conf').prop('disabled', true);
                    } else {
                        $('#btgravar').focus();
                    }
                });
            },
            mtdlocalizaregistro(id){
                var vself       = this;
                let loader      = vself.$loading.show();
                let filtro      = ' and c.id='+id;
                let parametros  = [
                    {parametro: 'op',           valor : 'listagem'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'filtro',       valor : filtro},
                    {parametro: 'limit',        valor : 1},
                    {parametro: 'offset',       valor : 0},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.mtdigualarcampos(response.data[0]);
                    if (parseInt(vself.opcrud) < 3){
                        $('#cbtipopessoa').focus();
                    }else{
                        $('#btgravar').focus();
                    }
                }).catch(function (response) {
                    loader.hide();
                });
            },
            mtdalterar(item){
                if (!util.opcaousuario('002Z.003M.002M', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    this.itensbc.item2.titulo = 'ALTERAÇÃO DE CLIENTES';
                    this.itensbc.item1.ativo  = true;
                    this.itensbc.item2.ativo  = true;
                    this.ativadesativa        = false;
                    this.mtdpreparacrud(2);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdexcluir(item){
                if (!util.opcaousuario('002Z.003M.003M', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    this.itensbc.item2.titulo = 'EXCLUSÃO DE CLIENTES';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    this.ativadesativa = true;
                    this.mtdpreparacrud(3);
                    this.mtdlocalizaregistro(item.id);
                }
            },
            mtdigualarcampos(registro){                
                this.vid                  = registro.id;
                this.vtipopessoa          = registro.tipopessoa;
                this.vreg                 = registro.reg;  
                this.vtipocontribuinte    = registro.tipocontribuinte;
                this.vsituacao            = registro.ativo;
                this.vnrcartao            = registro.nrcartao;
                this.vdtcadastro          = registro.dtcadastro;
                this.vnome                = registro.nome;
                this.vfantasia            = registro.fantasia;
                this.vavulso              = registro.avulso;

                //Variaveis endereço
                this.vcep                 = registro.cep;
                this.vlogradouro          = registro.logradouro;
                this.vnrendereco          = registro.nrendereco;
                this.vcomplementoend      = registro.complementoend;
                this.vperimetroend        = registro.perimetroend; 
                this.vidbairro            = registro.idbairro;
                this.vidmunicipio         = registro.idmunicipio;
                this.viduf                = registro.iduf;
                this.vidvendedor          = registro.idvendedor;
                this.vidcategoria         = registro.idcategoria === 0 ? null : registro.idcategoria; 
                this.vidrota              = registro.idrota === 0 ? null : registro.idrota; 

                var deffil                = new Option(registro.descfil, registro.idfilial, true, true);
                $('#cbfilial').append(deffil).trigger('change');

                var defbairro             = new Option(registro.descbairro, registro.idbairro, true, true);
                $('#cbbairro').append(defbairro).trigger('change');

                var defmunic              = new Option(registro.descmunic, registro.idmunicipio, true, true);
                $('#cbmunicipio').append(defmunic).trigger('change');
                
                var defuf                 = new Option(registro.descuf, registro.iduf, true, true);
                $('#cbuf').append(defuf).trigger('change');

                if (this.vidcategoria !== null){
                    var defcat                = new Option(registro.desccategoria, registro.idcategoria, true, true);
                    $('#cbcategoria').append(defcat).trigger('change');                
                }else{
                    $('#cbcategoria').val(null).trigger('change');
                }

                if (this.vidrota !== null){
                    var defrota                = new Option(registro.descrota, registro.idrota, true, true);
                    $('#cbrota').append(defrota).trigger('change');                
                }else{
                    $('#cbrota').val(null).trigger('change');
                }

                if (this.vidvendedor !== null){
                    var defvend               = new Option(registro.nomevendedor, registro.idvendedor, true, true);
                    $('#cbvendedor').append(defvend).trigger('change');
                }else{
                    $('#cbvendedor').val(null).trigger('change');
                }

                //Variaveis principal
                this.vcnpjcpf             = registro.cnpjcpf;
                this.vrginsc              = registro.rginsc;
                this.viepf                = registro.iepf;
                this.vinscsuframa         = registro.inscsuframa;
                this.videstrangeiro       = registro.idestrangeiro;
                this.vinscricaomunicipal  = registro.inscricaomunicipal;    
                this.vdtnascfund          = registro.dtnascfund;
                this.vcarteiraprof        = registro.carteiraprof; 
                this.vqtddependentes      = registro.qtddependentes; 
                this.vestadocivil         = registro.estadocivil;
                this.vnacionalidade       = registro.nacionalidade;
                this.vnaturalidade        = registro.naturalidade;
                this.vsexo                = registro.sexo;
                this.wt_residencia        = registro.residencia;
                this.vresidencia          = registro.residencia;
                this.vvlaluguel           = registro.vlaluguel;
                this.vfone1               = registro.fone1;
                this.vfone2               = registro.fone2;
                this.vfone3               = registro.fone3; 
                this.vcelular             = registro.celular;
                this.vcontato             = registro.contato;  
                this.vemail               = registro.email;
                this.vsite                = registro.site;
                this.vnomepai             = registro.nomepai;
                this.vnomemae             = registro.nomemae;
                
                //Variaveis trab/renda
                this.vlocaltrab           = registro.localtrab;
                this.vtiposervico         = registro.tiposervico;
                this.vcargotrab           = registro.cargotrab;
                this.vrendasalarial       = registro.rendasalarial;
                this.vrendaextra          = registro.rendaextra;
                this.venderecotrab        = registro.enderecotrab;
                this.vfonetrab            = registro.fonetrab;
                this.wt_possuibens        = registro.possuibens;
                this.vpossuibens          = registro.possuibens;
                this.voutrosbens          = registro.outrosbens;
                this.wt_possuioutroscred  = registro.possuioutroscred;
                this.vpossuioutroscred    = registro.possuioutroscred;
                this.voutroscred          = registro.outroscred;  

                //Variaveis do cônjuge
                this.vnomeconjuge         = registro.nomeconjuge;
                this.vcpfconjuge          = registro.cpfconjuge;
                this.vrgconjuge           = registro.rgconjuge; 
                this.vdtnascconjuge       = registro.dtnascconjuge;
                this.vpaiconjuge          = registro.paiconjuge;
                this.vmaeconjuge          = registro.maeconjuge;
                this.vlocaltrabconjuge    = registro.localtrabconjuge;
                this.vtpservicoconjuge    = registro.tpservicoconjuge;
                this.vfonetrabconjuge     = registro.fonetrabconjuge;
                this.vrendasalconjuge     = registro.rendasalconjuge;
                this.vrendaextraconjuge   = registro.rendaextraconjuge;

                //Variaveis fiador/referencia
                this.vnomefiador          = registro.nomefiador;
                this.vcpffiador           = registro.cpffiador;
                this.vrgfiador            = registro.rgfiador;
                this.vendfiador           = registro.endfiador;
                this.vfonefiador          = registro.fonefiador;
                this.vnomeref1            = registro.nomeref1;
                this.venderecoref1        = registro.enderecoref1;
                this.vfoneref1            = registro.foneref1; 
                this.vnomeref2            = registro.nomeref2;
                this.venderecoref2        = registro.enderecoref2;
                this.vfoneref2            = registro.foneref2; 

                //Variaveis crédito
                this.vvlcredito           = registro.vlcredito;
                this.vvlcreditosuple      = registro.vlcreditosuple;
                this.vqtddiasbloqvenda    = registro.qtddiasbloqvenda;
                this.vqtddiastolatraso    = registro.qtddiastolatraso;
                this.vvlmetames           = registro.vlmetames;
                this.vcobrartx            = registro.cobrartx;
                this.vtipovencimento      = registro.tipovencimento;
                this.vdiavencimento       = registro.diavencimento;
                this.vdiascarencia        = registro.diascarencia;
                this.vexigirentrada       = registro.exigirentrada;
                this.vpercentrada         = registro.percentrada;
                this.vutilizacusto        = registro.utilizacusto;
                this.wt_restringeCli      = registro.restringe;
                this.vrestringe           = registro.restringe;
                this.vmotivorestricao     = registro.motivorestricao;
                this.vdiretorioimagem     = registro.diretorioimagem === '' ? util.GerarStringAleatoria() : registro.diretorioimagem;
                this.vimagemcliente       = registro.imagemcliente;                
                
                this.pathimagemvisualizar = this.pathimgview+this.vimagemcliente;

                //Variaveis planos de pagamento
                this.lstplanospagamento   = registro.planospagamento;

                this.vobservacoes         = registro.observacoes;
                this.vidfilial            = registro.idfilial;                
            },
            mtdregistro(){
                let vself  = this;
                let loader = vself.$loading.show();                
                let registrocrud = {
                    'id'                  : this.vid,
                    'tipopessoa'          : this.vtipopessoa,
                    'tipocontribuinte'    : this.vtipocontribuinte,
                    'ativo'               : this.vsituacao,
                    'nrcartao'            : this.vnrcartao,
                    'dtcadastro'          : this.vdtcadastro,
                    'nome'                : this.vnome,
                    'fantasia'            : this.vfantasia,
                    'avulso'              : this.vavulso,  

                    //Variaveis endereço
                    'cep'                 : this.vcep.replace(/[^0-9]/g,''),
                    'logradouro'          : this.vlogradouro,
                    'nrendereco'          : this.vnrendereco,
                    'complementoend'      : this.vcomplementoend,
                    'perimetroend'        : this.vperimetroend, 
                    'idbairro'            : this.vidbairro,
                    'idmunicipio'         : this.vidmunicipio,
                    'iduf'                : this.viduf,
                    'idcategoria'         : this.vidcategoria === null ? 0 : this.vidcategoria,  
                    'idrota'              : this.vidrota === null ? 0 : this.vidrota,  

                    //Variaveis principal
                    'cnpjcpf'             : this.vcnpjcpf.replace(/[^0-9]/g,''),
                    'rginsc'              : this.vrginsc,
                    'iepf'                : this.viepf,  
                    'inscsuframa'         : this.vinscsuframa,
                    'idestrangeiro'       : this.videstrangeiro,
                    'inscricaomunicipal'  : this.vinscricaomunicipal,
                    'dtnascfund'          : this.vdtnascfund,
                    'carteiraprof'        : this.vcarteiraprof, 
                    'qtddependentes'      : this.vqtddependentes, 
                    'estadocivil'         : this.vestadocivil,
                    'nacionalidade'       : this.vnacionalidade,
                    'naturalidade'        : this.vnaturalidade,
                    'sexo'                : this.vsexo,
                    'residencia'          : this.vresidencia,
                    'vlaluguel'           : this.vvlaluguel,
                    'fone1'               : this.vfone1.replace(/[^0-9]/g,''),
                    'fone2'               : this.vfone2.replace(/[^0-9]/g,''),
                    'fone3'               : this.vfone3.replace(/[^0-9]/g,''),
                    'celular'             : this.vcelular.replace(/[^0-9]/g,''),
                    'contato'             : this.vcontato,  
                    'email'               : this.vemail,
                    'site'                : this.vsite,
                    'nomepai'             : this.vnomepai,
                    'nomemae'             : this.vnomemae,
                    
                    //Variaveis trab/renda
                    'localtrab'           : this.vlocaltrab,
                    'tiposervico'         : this.vtiposervico,
                    'cargotrab'           : this.vcargotrab,
                    'rendasalarial'       : this.vrendasalarial,
                    'rendaextra'          : this.vrendaextra,
                    'enderecotrab'        : this.venderecotrab,
                    'fonetrab'            : this.vfonetrab.replace(/[^0-9]/g,''),
                    'possuibens'          : this.vpossuibens,
                    'outrosbens'          : this.voutrosbens,
                    'possuioutroscred'    : this.vpossuioutroscred,
                    'outroscred'          : this.voutroscred,  

                    //Variaveis do cônjuge
                    'nomeconjuge'         : this.vnomeconjuge,
                    'cpfconjuge'          : this.vcpfconjuge.replace(/[^0-9]/g,''),
                    'rgconjuge'           : this.vrgconjuge, 
                    'dtnascconjuge'       : this.vdtnascconjuge,
                    'paiconjuge'          : this.vpaiconjuge,
                    'maeconjuge'          : this.vmaeconjuge,
                    'localtrabconjuge'    : this.vlocaltrabconjuge,
                    'tpservicoconjuge'    : this.vtpservicoconjuge,
                    'fonetrabconjuge'     : this.vfonetrabconjuge.replace(/[^0-9]/g,''),
                    'rendasalconjuge'     : this.vrendasalconjuge,
                    'rendaextraconjuge'   : this.vrendaextraconjuge,

                    //Variaveis fiador/referencia
                    'nomefiador'          : this.vnomefiador,
                    'cpffiador'           : this.vcpffiador.replace(/[^0-9]/g,''),
                    'rgfiador'            : this.vrgfiador,
                    'endfiador'           : this.vendfiador,
                    'fonefiador'          : this.vfonefiador.replace(/[^0-9]/g,''),
                    'nomeref1'            : this.vnomeref1,
                    'enderecoref1'        : this.venderecoref1,
                    'foneref1'            : this.vfoneref1.replace(/[^0-9]/g,''),
                    'nomeref2'            : this.vnomeref2,
                    'enderecoref2'        : this.venderecoref2,
                    'foneref2'            : this.vfoneref2.replace(/[^0-9]/g,''),

                    //Variaveis crédito
                    'vlcredito'           : this.vvlcredito,
                    'vlcreditosuple'      : this.vvlcreditosuple,
                    'qtddiasbloqvenda'    : this.vqtddiasbloqvenda,
                    'qtddiastolatraso'    : this.vqtddiastolatraso,
                    'vlmetames'           : this.vvlmetames,
                    'cobrartx'            : this.vcobrartx,
                    'tipovencimento'      : this.vtipovencimento,
                    'diavencimento'       : this.vdiavencimento,
                    'diascarencia'        : this.vdiascarencia,
                    'exigirentrada'       : this.vexigirentrada,
                    'percentrada'         : this.vpercentrada,
                    'utilizacusto'        : this.vutilizacusto,
                    'restringe'           : this.vrestringe,
                    'motivorestricao'     : this.vmotivorestricao,
                    'reg'                 : parseInt(this.vreg) === 0 ? 1 : 0,   
                    'diretorioimagem'     : this.vdiretorioimagem,
                    'imagemcliente'       : this.vimagemcliente,                
            

                    //Variaveis planos de pagamento
                    'planospagamento'     : this.lstplanospagamento,

                    'observacoes'         : this.vobservacoes,
                    'idfilial'            : this.vidfilial,
                    'idvendedor'          : this.vidvendedor
                };
                let parametros      = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'diretorioimagens', valor : vself.$store.state.configpaths.pathimgclientes+vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',               valor : 'rotinacrud'},
                    {parametro: 'opcrud',           valor : vself.opcrud},
                    {parametro: 'registro',         valor : JSON.stringify(registrocrud)},
                    {parametro: 'idfilial',         valor : vself.$store.state.filialpadrao.codfil},
                    {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                    {parametro: 'codop',            valor : parseInt(vself.opcrud) === 1 ? '002Z.003M.001M' : parseInt(vself.opcrud) === 2 ? '002Z.003M.002M' : '002Z.003M.003M'},
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
                retorno.then(function (response) {
                    loader.hide();
                    if ($.isNumeric(response.data)){
                        util.notif("success", 'Registro processado com sucesso!')
                        vself.pfiltro       = 0;
                        vself.pconteudo     = parseInt(vself.opcrud) === 1 ? response.data : vself.vid;
                        vself.pqtd_paginas  = 1;
                        vself.mtdcancelaredicao();
                        vself.mtdcarregaclientes(1);
                    }else{
                        let tpret = response.data.substring(0,1);
                        switch (tpret) {
                            case 'I':
                                util.notif("warning", response.data.substring(4))
                                break;
                            case 'E': default:
                                util.notif("error", response.data.substring(4))
                                break;
                        }
                    }
                }).catch(function (response) {
                    loader.hide();
                    util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                });
            },
            formatacpfcnpj(val) {
                return util.formatacpfcnpj(val);
            },             
            mtdselect2_def(){
                let vself  = this;

                $("#edcep").blur(function(){
                    vself.mtdpesquisacep();
                });

				$("#cbmunicipiopesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbmunicipios',
								c1: 'id',
								c2: 'descricao'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidmunicipio = $("#cbmunicipiopesq").val();
				});

				$("#cbvendedorpesq").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.pidvendedor = $("#cbvendedorpesq").val();
				});

                $("#cbcategoriapesq").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbcategorias',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.pidcategoria = $("#cbcategoriapesq").val();
                });  
                
                $("#cbrotapesq").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbrotas',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.pidrota = $("#cbrotapesq").val();
                });                

                $("#edcnpjcpf").blur(function(){
                    vself.mtdverificadocumento(parseInt(vself.opcrud));
                });                

				$("#cbvendedor").select2({
					id: function (e) {return e.id},
					ajax: {
						url: vself.$store.state.configpaths.pathselect2,
						dataType: 'json',
						delay: 250,
						data: function (params) {
							return {
								q: params.term,
								idclientesac : vself.$store.state.filialpadrao.idcliente,
								tb: 'tbvendedores',
								c1: 'id',
								c2: 'nome'
							};
						},
						processResults: function (data) {
							return {
								results: data
							};
						},
						cache: true
					},
					minimumInputLength: 0,
					theme: 'bootstrap',
					language: "pt-BR",
					templateResult: util.formatResult,
					templateSelection: util.formatSelection
				}).change(function () {
					vself.vidvendedor = $("#cbvendedor").val();
				});

                $("#cbbairro").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbbairros',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 1,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidbairro = $("#cbbairro").val();
                });                

                $("#cbmunicipio").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbmunicipios',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 3,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidmunicipio = $("#cbmunicipio").val();
                });
                
                $("#cbcategoria").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbcategorias',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidcategoria = $("#cbcategoria").val();
                });

                $("#cbrota").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbrotas',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidrota = $("#cbrota").val();
                });

                $("#cbfilial").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbfiliais',
                                c1: 'codfil',
                                c2: 'descfil'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidfilial = $("#cbfilial").val();
                });                

                $("#cbuf").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbufs',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.viduf = $("#cbuf").val();
                });
                
                $("#cbplanopagamento").select2({
                    id: function (e) {return e.id},
                    ajax: {
                        url: vself.$store.state.configpaths.pathselect2,
                        dataType: 'json',
                        delay: 250,
                        data: function (params) {
                            return {
                                q: params.term,
                                idclientesac : vself.$store.state.filialpadrao.idcliente,
                                tb: 'tbplanospagamento',
                                c1: 'id',
                                c2: 'descricao'
                            };
                        },
                        processResults: function (data) {
                            return {
                                results: data
                            };
                        },
                        cache: true
                    },
                    minimumInputLength: 0,
                    theme: 'bootstrap',
                    language: "pt-BR",
                    templateResult: util.formatResult,
                    templateSelection: util.formatSelection
                }).change(function () {
                    vself.vidplano = $("#cbplanopagamento").val();
                });
                //atribuição de planos
                $("#cbplanoatribuir").select2({
                        id: function (e) {return e.id},
                        ajax: {
                            url: vself.$store.state.configpaths.pathselect2,
                            dataType: 'json',
                            delay: 250,
                            data: function (params) {
                                return {
                                    q: params.term,
                                    idclientesac : vself.$store.state.filialpadrao.idcliente,
                                    tb: 'tbplanospagamento',
                                    c1: 'id',
                                    c2: 'descricao'
                                };
                            },
                            processResults: function (data) {
                                return {
                                    results: data
                                };
                            },
                            cache: true
                        },
                        minimumInputLength: 0,
                        theme: 'bootstrap',
                        language: "pt-BR",
                        templateResult: util.formatResult,
                        templateSelection: util.formatSelection
                    }
                ).change(function () {
                    vself.vidplanoatribuir = $("#cbplanoatribuir").val();
                });                    
            },
            mtdincluiplanos() {
                if (this.vidplano === null){
                    util.notif("warning", 'Plano de pagamento deve ser informado!');
                    $("#cbplanopagamento").focus();
                    return;
                }
                if (!util.findValInArray(this.lstplanospagamento, 'id', this.vidplano)) {
                    let plano_tmp = {
                        'id'         : this.vidplano,
                        'descricao'  : $('#cbplanopagamento').select2('data')[0]['text']
                    };
                    this.lstplanospagamento.push(plano_tmp);
                    $("#cbplanopagamento").val('').trigger('change');
                    this.vidplano  = null;
                }else{
                    util.notif("warning", 'Plano de pagamento já informado!');
                }
                $("#cbplanopagamento").focus();
            },
            mtdexcluirplano: function (plano) {
                this.lstplanospagamento.splice(util.getArrayIndexForKey(this.lstplanospagamento, 'id', plano.id), 1);
            },
            mtdincluirtodosplano: function () {
                let vself                = this;
                Swal.fire({
                    customClass: {
                        confirmButton: "btn btn-success conf",
                        cancelButton: "btn btn-danger"
                    },
                    title: "Confirmação",
                    text: 'Deseja mesmo adicionar todos os planos?',
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Fechar"
                }).then((result) => {
                    if (result.isConfirmed) {
                        $('.conf').prop('disabled', true);
                        let loader               = vself.$loading.show();
                        let parametros           = [
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'op',           valor : 'buscaplanos'}
                        ];                
                        let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
                        retorno.then(function (response) {
                            loader.hide();
                            vself.lstplanospagamento = [];

                            let i                = 0;
                            let len              = response.data.length;

                            for (; i < len; ) {
                                i++;

                                let newListaPlano = {
                                    'id'            : response.data[i-1]['id'],
                                    'descricao'     : response.data[i-1]['descricao']
                                };

                                if (!util.findValInArray(vself.lstplanospagamento, 'id', newListaPlano.id)) {
                                    vself.lstplanospagamento.push(newListaPlano);
                                }
                            }
                        }).catch(function (response) {
                            loader.hide();
                            util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                        });
                    } else {
                        $('#btinctodosplanos').focus();
                    }
                });
                            
            },
            mtdexcluirtodosplanos: function () {
                let vself                = this;
                Swal.fire({
                    customClass: {
                        confirmButton: "btn btn-success conf",
                        cancelButton: "btn btn-danger"
                    },
                    title: "Confirmação",
                    text: 'Deseja mesmo excluir todos os planos?',
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Fechar"
                }).then((result) => {
                    if (result.isConfirmed) {
                        $('.conf').prop('disabled', true);
                        vself.lstplanospagamento = [];
                    } else {
                        $('#btexctodosplanos').focus();
                    }
                });                                
            },
            mtdpesquisacep(){
                let vself = this;
                let cepinf = vself.vcep;
                if ( cepinf != ''){
                    if (util.IsCEP(cepinf, '')){
                        let loader = vself.$loading.show();
                        let parametros = [
                            {parametro: 'param1', 		valor: 'consultarcep'},
                            {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                            {parametro: 'cep', 			valor: cepinf}
                        ];
                        let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/buscarcep.php');
                        retorno.then(function (response) {
                            loader.hide();
                            if (response.data != '0') {
                                var defmun            = new Option(response.data.descmunicipio, response.data.idmunicipio, true, true);
                                $('#cbmunicipio').append(defmun).trigger('change');

                                var defbai            = new Option(response.data.descbairro, response.data.idbairro, true, true);
                                $('#cbbairro').append(defbai).trigger('change');

                                var defuf             = new Option(response.data.descuf, response.data.iduf, true, true);
                                $('#cbuf').append(defuf).trigger('change');

                                vself.vlogradouro     = response.data.logradouro;
                                vself.vreferencia     = response.data.complemento;
                            }else{
                                util.notif("warning", 'CEP inválido ou inexistente!');
                            }					

                        }).catch(function (response) {
                            loader.hide();
                            console.log(response.message);
                        });
                    }
                }                
            },
            mtdverificadocumento(op){
                let vself = this;

                if(op < 3){
                    let docinf = vself.vcnpjcpf;
                    if ( docinf != ''){
                        let loader = vself.$loading.show();
                    let registrodoc     = {
                        'idc'     : vself.vid,
                        'acao'    : op, 
                        'doc'     : vself.vcnpjcpf                  
                    }
                    let parametros      = [
                        {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                        {parametro: 'op',           valor : 'verificadoc'},
                        {parametro: 'registro',     valor : JSON.stringify(registrodoc)}
                    ];
                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
                        retorno.then(function (response) {
                            loader.hide();
                            if (response.data != '0') {
                                if(parseInt(vself.vtipopessoa) === 0){
                                    util.notif("warning", 'CPF já cadastrado no sistema!');
                                }else{
                                    util.notif("warning", 'CNPJ já cadastrado no sistema!');
                                } 
                                $('#edcnpjcpf').focus();                           
                            }					

                        }).catch(function (response) {
                            loader.hide();
                            console.log(response.message);
                        });
                    } 
                }                
            },
            mtdrotinaimportacao(){
                if (!util.opcaousuario('002Z.003M.004M', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {
                    this.itensbc.item2.titulo = 'CENTRAL DE IMPORTAÇÃO DE CLIENTES';
                    this.itensbc.item1.ativo = true;
                    this.itensbc.item2.ativo = true;
                    $('#pnlista').hide();
                    this.resetarDados();
                    this.arqselecionado = null;
                    this.vlimpardados   = false;
                    this.vadicionaraocadastro = false;
                    this.vimportarcodigos   = false;
                    $('#pnimportacao').fadeIn(700);
                }                
            },
            mtdbaixarmatriz(){
                window.open('https://dracosys.top/controller/arquivosimportacao/manager/matrizes/matrizimportarclientes.xls', '_blank');
            },
            mtdselecionararquivo(event){                
                let vself            = this;                 
                vself.arqselecionado = event.target.files[0];

                let extarq  = vself.arqselecionado.name.substring(vself.arqselecionado.name.lastIndexOf('.') + 1);
                if (extarq.toUpperCase() !== 'XLS'){
                    vself.arqselecionado = null;
                    util.notif("warning", 'O arquivo selecionado não possui um formato válido');
                    return;
                }

                let loader      = vself.$loading.show();
                let localsalvar = 'controller/arquivosimportacao/manager/'+
                                  vself.$store.state.filialpadrao.idcliente;

                let parametros      = [
                    {parametro: 'arquivo',          valor  : vself.arqselecionado},
                    {parametro: 'localsalvar',      valor  : localsalvar},
                    {parametro: 'nomearquivo',      valor  : vself.arqselecionado.name}
                ];
                let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/uploadfile.php');
                retorno.then(function (response) {
                    if ($.isNumeric(response.data.inf)){
                        vself.mtdcancelaredicao();
                        vself.lstclientes= [];
                        vself.pqtd_paginas   = 0;                                                
                        let oplimpar         = vself.vlimpardados === false ? '0' : '1';
                        let opcodigos        = vself.vimportarcodigos === false ? '0' : '1';
                        let opaddcad         = vself.vadicionaraocadastro === false ? '0' : '1';
                        let url              = 'https://www.'+vself.$store.state.usuario.adrsrv+'/controller/importadores/manager/importarclientes.php?idclientesac='+vself.$store.state.filialpadrao.idcliente+
                                               '&arquivoimportar='+vself.arqselecionado.name+'&limparcadastro='+oplimpar+
                                               '&idfilial='+vself.$store.state.filialpadrao.codfil+'&idu='+
                                               vself.$store.state.usuario.id+'&importarcodigos='+opcodigos+'&addcad='+opaddcad+'&codop=002Z.003M.004M';
                        vself.arqselecionado = null;                                               
                        window.open(url, '_blank');                        
                    }else{
                        vself.arqselecionado = null;
                        $('#ipselecionararquivo').val('');
                        util.notif("error", 'Descrição do erro: '+response.data)
                    }
                    loader.hide();
                }).catch(function (response) {
                    loader.hide();
                    util.notif("error", 'Descrição do erro: '+response.message)
                    vself.arqselecionado = null;
                    $('#ipselecionararquivo').val('');
                });                
            },
            mtdexportarexcel(){
                $('#btexportarexcel').click();
            },
            mtdgerarpdf(excelpin){
                var excel = 0
                    if(excelpin){// exportar excel
                        excel = 1
                    }
                let vself   = this;
                let filtro  = vself.mtdfiltropesquisa();

                Swal.fire({
                    customClass: {
                        confirmButton: "btn btn-success conf",
                        cancelButton: "btn btn-danger"
                    },
                    title: "Confirmação",
                    text: 'MOSTRAR ENDEREÇO do cliente na listagem?',
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    allowOutsideClick: false,
                    confirmButtonText: "Sim",
                    cancelButtonText: "Fechar"
                }).then((result) => {
                    if (result.isConfirmed) {
                        window.open(vself.$store.state.configpaths.pathcontrole+'rtcadclientes.php?idclientesac='+
                                            vself.$store.state.filialpadrao.idcliente+
                                            '&filtro='+filtro+
                                            '&mostraend='+1+
                                            '&excel='+excel+
                                            '&usuario='+vself.$store.state.usuario.nome, '_blank');	
                    } else {
                        window.open(vself.$store.state.configpaths.pathcontrole+'rtcadclientes.php?idclientesac='+
                                            vself.$store.state.filialpadrao.idcliente+
                                            '&filtro='+filtro+
                                            '&mostraend='+0+
                                            '&excel='+excel+
                                            '&usuario='+vself.$store.state.usuario.nome, '_blank');	
                    }
                });
                
            },
            /// rotinas da atribuição do plano de pagamneto - by GUGA
            mtdrotinaplano(){
                if (!util.opcaousuario('002Z.003M.010M', this.$store.state.perfilusuario)){
                    util.notif("warning", 'Acesso não permitido para o usuário!');
                }else {                
                    if (this.$refs.reflstclientes.selected_items.length === 0){
                        util.notif("warning", 'Selecione os clientes para a atribuição do plano!');
                        return;
                    }
                    this.vopcaoplanoatribuir  = 0; 
                    this.vatribuitodoscli = false;
                    $('#cbplanoatribuir').val(null).trigger('change'); 
                    this.listarplanosatr();                               
                    $('#mdatribuirplano').modal('show');
                }        
            },
            listarplanosatr(){
                var vself       = this;
                let loader      = this.$loading.show();
                let parametros  = [
                    {parametro: 'idclientesac', valor  : vself.$store.state.filialpadrao.idcliente},
                    {parametro: 'op',           valor : 'listarplanos'},
                ];
                let retorno           = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
                retorno.then(function (response) {
                    vself.lstplanosatribuir = response.data;
                    loader.hide();
                }).catch(function (response) {
                    vself.lstplanosatribuir = [];
                    loader.hide();
                });
            },
            mtdaplicaselecao(valoratribuir){
                for (let i = 0; i < this.lstplanosatribuir.length; i++) {
                    if(this.lstplanosatribuir[i].marcado == 1 ){
                        this.lstplanosselec.push(this.lstplanosatribuir[i].id); 
                    }
                } 
                this.mtdatribuirplano();
                 
            },
            mtdhabilita(index){  
                util.habilita(this.lstplanosatribuir, 'marcado', index);
            },
            mtdmarcartodas(){
                util.marcartodas(this.lstplanosatribuir, 'marcado');
            },
            mtdatribuirplano(){
                let vself = this;
				if (this.lstplanosselec.length === 0){
                    util.notif("warning", 'O plano deve ser informado!');
					return;
                } 
                
                Swal.fire({
                    customClass: {
                        confirmButton: "btn btn-success conf",
                        cancelButton: "btn btn-danger"
                    },
                    title: "Confirmação",
                    text: 'Confirma a atribuição do plano para os clientes selecionados?',
                    icon: "question",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "Sim",
                    cancelButtonText: "Fechar"
                }).then((result) => {
                    if (result.isConfirmed) {
                        $('.conf').prop('disabled', true);
                        setTimeout(function(){                                    
                                    let lstclientesatribuir = [];
                                    for (let cliente of vself.$refs.reflstclientes.selected_items) {
                                        lstclientesatribuir.push(cliente.id);
                                    }
                                    let loader = vself.$loading.show();
                                    let parametros      = [
                                        {parametro: 'idclientesac',     valor : vself.$store.state.filialpadrao.idcliente},
                                        {parametro: 'op',               valor : 'atribuirplano'},
                                        {parametro: 'opcaoplano',       valor : vself.vopcaoplanoatribuir},                                        
                                        {parametro: 'clientes',         valor : JSON.stringify(lstclientesatribuir)},
                                        {parametro: 'idplanos',         valor : JSON.stringify(vself.lstplanosselec)},
                                        {parametro: 'idusuario',        valor : vself.$store.state.usuario.id},
                                        {parametro: 'todosclientes',    valor : vself.vatribuitodoscli === false ? 0 : 1},
                                        {parametro: 'codop',            valor : '002Z.003M.010M'},
                                    ];
                                    let retorno     = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rtcadclientes.php');
                                    retorno.then(function (response) {
                                        loader.hide();
                                        if ($.isNumeric(response.data)){
                                            $('#mdatribuirplano').modal('hide');
                                            util.notif("success", 'Registro processado com sucesso!')
                                            vself.pqtd_paginas  = 1;
                                            vself.mtdcancelaredicao();
                                            // vself.mtdcarregaprodutos(1);
                                        }else{
                                            let tpret = response.data.substring(0,1);
                                            switch (tpret) {
                                                case 'I':
                                                    util.notif("warning", response.data.substring(4))
                                                    break;
                                                case 'E': default:
                                                    util.notif("error", response.data.substring(4))
                                                    break;
                                            }
                                        }
                                        vself.lstplanosselec = [];
                                        vself.$refs.reflstclientes.selected_items = []
                                    }).catch(function (response) {
                                        vself.lstplanosselec = [];
                                        vself.$refs.reflstclientes.selected_items = []
                                        loader.hide();
                                        util.notif("error", 'Erro ao processar o registo. Descrição do erro: ' + response.message);
                                    });                                    
                                },200);     
                    } else {
                        $('#btconfirmar').focus();
                    }
                });            
            },
            mtdmaisfiltros(){
                this.pdtini = util.DataAtual(true);
                this.pdtfim = util.DataAtual(true);
                this.pfiltroadquiridospesq = 0;
                // this.pfiltroncmpesq      = 2;
                if (this.pmaisfiltros === true){
                    this.pmaisfiltros = false;
                }else{
                    this.pmaisfiltros = true;
                }
            }                                    
        },
        mounted: function () {
            if (util.verificasessao(this)) {
                let vself = this;
                let loader = vself.$loading.show();
                let parametros = [
                    {parametro: 'op', valor: 'dadosusuario'},
                    {parametro: 'idclientesac', valor  : vself.$store.state.usuario.idclientesac},
                    {parametro: 'idusuario', valor: vself.$store.state.usuario.id}
                ];
                let retorno = util.reqaxios(parametros, 'post', vself.$store.state.usuario.adrsrv+'/controller/rotinasusuario.php');
                retorno.then(function (response) {
                    loader.hide();
                    vself.$store.commit('MUDAR_PERFIL_USUARIO', response.data.perfilusu);
                    if (util.opcaousuario('002Z.003M', vself.$store.state.perfilusuario)) {
                        vself.pathimgview         = vself.$store.state.configpaths.pathimagens;
                        $('#pnlista').fadeIn(700);
                        vself.mtdexecutapesquisa();
                        vself.mtdselect2_def();
                    } else {
                        util.notif("warning", 'Acesso não permitido para o usuário!');
                        setTimeout(function(){
                            util.gotoprincipal();
                        },1000);
                    }
                }).catch(function (response) {
                    loader.hide();
                    console.log(response.message);
                });
            }
        },
        computed:{
            validou: function () {
                return this.vnome === '' || this.vfantasia === '' || this.vfone1 === '' || this.vlogradouro === '' || this.vnrendereco === '' ||
                    this.vcep === '' || this.vidbairro === null || this.vidmunicipio === null || this.viduf === '' || 
                    this.vidfilial === null || this.vidvendedor === null;
            }
        },
        watch:{
            pagina_atual(val){
                this.mtdcarregaclientes(val);
            },
            vlimpardados(val){
                this.vimportarcodigos = false;
                this.vadicionaraocadastro = false;
            },
            wt_residencia: function (val) {
                this.vresidencia                    = parseInt(val);

                if(this.vresidencia === 1){
                    this.labelCustoCasa             = 'Valor aluguel:';
                    this.bativaCustoCasa            = false;
                }else{
                    if(this.vresidencia === 2){
                        this.labelCustoCasa         = 'Valor parcela:';
                        this.bativaCustoCasa        = false;
                    }else{
                        this.labelCustoCasa         = 'Nenhum:';
                        this.bativaCustoCasa        = true;
                        this.vvlaluguel             = 0;
                    }
                }

                if(this.ativadesativa) {
                    this.bativaCustoCasa            = true;
                }
            },
            wt_restringeCli: function (val) {
                this.vrestringe                     = parseInt(val);

                if(this.vrestringe === 0){
                    this.vmotivorestricao           = '';
                    this.bmotivoRestringe           = true;
                }else{
                    if(this.vrestringe === 1){
                        this.bmotivoRestringe       = false;

                        if(this.ativadesativa) {
                            this.bmotivoRestringe   = true; 
                        }
                    }
                }
            },
            wt_possuibens: function (val) {
                this.vpossuibens                    = parseInt(val);

                if(this.vpossuibens === 0){
                    this.voutrosbens                = '';
                    this.bpossuibens                = true;
                }else{
                    if(this.vpossuibens === 1){
                        this.bpossuibens            = false;

                        if(this.ativadesativa){
                            this.bpossuibens        = true;
                        }
                    }
                }
            },
            wt_possuioutroscred: function (val) {
                this.vpossuioutroscred              = parseInt(val);

                if(this.vpossuioutroscred === 0){
                    this.voutroscred                = '';
                    this.bpossuioutroscred          = true;
                }else{
                    if(this.vpossuioutroscred === 1){
                        this.bpossuioutroscred      = false;

                        if(this.ativadesativa) {
                            this.bpossuioutroscred  = true;
                        }
                    }
                }                
            },
            wt_tipovencimento: function (val) {
                this.vtipovencimento                = parseInt(val);

                if(this.vtipovencimento === 0){
                    this.btipovencimento            = true;
                }else{
                    if(this.vtipovencimento === 1){
                        this.btipovencimento        = false;
                    }
                }                 
            },
            wt_exigirentrada: function (val) {
                this.vexigirentrada                 = parseInt(val);

                if(this.vexigirentrada === 0){
                    this.bexigirentrada             = true;
                }else{
                    if(this.vexigirentrada === 1){
                        this.bexigirentrada         = false;
                    }
                }                
            }
        }       
    }
</script>

<style>
    .def-col-cod{
        width: 80px !important;
    }
    .def-col-fone{
        width: 120px !important;
    }     
    .def-col-cnpjcpf{
        width: 150px !important;
    }
    .def-col-ativo{
        width: 80px !important;
    }
    .def-col-tipopessoa{
        width: 80px !important;
    }    
    #btclonarperfilusuario{
        cursor: pointer;
        font-weight: bold;
        font-size: 18px;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodosopusuario{
        font-weight: bold;
        font-size: 18px;
        padding-right: 10px;
        cursor: pointer;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodosopusuario:hover{
        color: #666666;
        transition: .35s;
    }

    #btmarcartodfiliais{
        font-weight: bold;
        font-size: 18px;
        padding-right: 10px;
        cursor: pointer;
        position: relative;
        float: right;
        top: 5px;
        transition: .35s;
    }
    #btmarcartodfiliais:hover{
        color: #666666;
        transition: .35s;
    }
    #btclonarperfilusuario:hover{
        color: #666666;
        transition: .35s;
    }
    .excplanos{
        color: #8c8b8b;
        font-size: 22px;
    }
    .titplanos{
        font-size: 14px;
    }
    .img-cliente{
        cursor: pointer;
        width: 150px !important;
        height: 155px !important;
    }
    .btn-del-imgcliente{
        position: absolute;
        top: 10px;
        left: 10px;
    }    
</style>